(function ($) {
    (function ($, sr) {
        var debounce = function (func, threshold, execAsap) {
            var timeout;
            return function debounced() {
                var obj = this, args = arguments;

                function delayed() {
                    if (!execAsap)
                        func.apply(obj, args);
                    timeout = null;
                };
                if (timeout)
                    clearTimeout(timeout);
                else if (execAsap)
                    func.apply(obj, args);

                timeout = setTimeout(delayed, threshold || 100);
            };
        }
        // smartresize
        jQuery.fn[sr] = function (fn) {
            return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
        };
    })(jQuery, 'smartresize');


    function tajexotica_refresh_size_queries() {
        var scrollbarwidth = tajexotica_get_scroll_bar_width();
        var window_width = $(window).width() + scrollbarwidth;
        var window_height = $(window).height();
        window.is_phone = (window_width < 768);
        window.is_mobile = (window_width < 992);
        window.is_tablet_portrait = (window_width >= 768 && window_width < 992);
        var is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
        var is_tablet = is_tablet_portrait || is_tablet_landscape;
        var is_desktop = (window_width >= 992);
        var is_desktop_large = (window_width >= 1200);
        var is_desktop_xxl = (window_width >= 1700 && window_height >= 800);
    }

    function tajexotica_get_scroll_bar_width() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    }

    // Run when the screen is resized
    jQuery(window).smartresize(function () {
        tajexotica_refresh_size_queries();
        tajexotica_headerPosition();
        tajexotica_scrollbar();
        if (window.matchMedia('(min-width: 994px)').matches) {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
        // Refresh ScrollTrigger
        setTimeout(function () {
            ScrollTrigger.refresh(true);
        }, 500);
    });

    (function () {

        // Body
        window.bodySelectCheck = document.body;
        // Html
        window.html_tag = document.getElementsByTagName("html")[0];
        // Head
        window.wDoc = window.document;
        window.head_tag = wDoc.getElementsByTagName("head")[0];

        // Different checks for the body Template Homepage
        window.isTmpHomepage = bodySelectCheck.classList.contains('page-template-template-homepage');
        window.rusCheck = bodySelectCheck.classList.contains('is_russ');
        window.isRtlCheck = bodySelectCheck.classList.contains('is_rtl_page');

        // IO is On
        window.iObserver = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window
            && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;

        var mediaDesktop = window.matchMedia('(min-width: 994px)').matches;
        if (bodySelectCheck.classList.contains('enable-smooth-scroll') && mediaDesktop) {
            window.rootIO = document.getElementById('scroll-wrapper')  // ScrollSmoother Integration
        } else {
            window.rootIO = null;
        }

        // window.rootIO = null; // With null is working but is not getting the exact rootMargin

        window.playerRun = null;

        // This condition should be before the instant-page
        window.FPConfig = {
            delay: 99999, // Start after seconds
            ignoreKeywords: ['javascript', '#'], // Ignore links. If no gives error javascript
            maxRPS: 1, // Max link on the viewport added each second Set to 0 to process all requests immediately (without queue)
            hoverDelay: 25, // Start loading after ms on Hover
        };

        var containerMenuHeight = $('.container-full-menu').height(); // For Video Plyr Full Height
        // The 5 is to remove any white line
        document.documentElement.style.setProperty('--container-menu-height', containerMenuHeight - 5 + 'px');

        let docStyle = getComputedStyle(document.documentElement);
        window.heightAnimSpeed = docStyle.getPropertyValue('--height-animation-speed');
    })();

    window.loadCSS_fast = function (link_style, id_style = 'loadcss_fast', before) {
        // Remember to send the ID of the CSS to make the validation
        // Check with ID
        var check_exist_css = document.getElementById(id_style);
        if (check_exist_css == null) {
            var link = document.createElement("link");

            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = link_style;
            link.id = id_style;

            // If before is send insert before the ID
            // If before is empty insert before the head close
            var ref;
            if (before) {
                ref = document.getElementById(before);
            } else {
                var refs = (head_tag || wDoc.body).childNodes;
                ref = refs[refs.length - 1];
            }
            ref.parentNode.insertBefore(link, (before ? ref : ref.nextSibling));
            console.log('Asset loaded ' + id_style);

        }
    }

    jQuery(document).ready(function () {
        // Size screen
        tajexotica_refresh_size_queries();
        tajexotica_scrollbar(); // Added opacity while is loading to don't show the old scrollbar

        // Improve the performance with Debounce and Throttle
        // Avoid menu blinking mobile
        if (!is_mobile) {
            window.addEventListener('scroll', tajexotica_throttle(tajexotica_headerPosition, 25));
        } else {
            window.addEventListener('scroll', tajexotica_headerPosition);
        }


        // Scroll Header
        tajexotica_headerPosition();

        // if (!is_mobile) {
        //     tajexotica_prog_slideshow();
        // } else {
        //     if (!isTmpHomepage) {
        //         tajexotica_prog_slideshow();
        //     }
        // }

        tajexotica_ewdelay_or_interaction_js();

        // Run all the sliders
        if (!isTmpHomepage) {
            tajexotica_fancybox_popup();
            tajexotica_fullwidth_slideshow();
            tajexotica_slider_thumbnail();
        }

        // IntersectionObserver
        tajexotica_lazy_load_img();

        tajexotica_read_more();

        // Fancybox & Slider
        if (!isTmpHomepage) {
            tajexotica_fancybox_callback();
            tajexotica_fancybox_photogallery();
            tajexotica_slider_full();
            tajexotica_slider_small();
        }

        tajexotica_filter_line();
        // if (is_mobile) {
        tajexotica_filter_select();
        // }

        if (!is_mobile) {
            tajexotica_filter_photogallery();
        }

        if (is_mobile) {
            // Filters with select for mobile
            var grid_offers = $('.photogallery-block');
            if (grid_offers.length > 0) {
                var filterselect_of = $('#select-filter-photogallery');
                var item_block_of = '.item-photogallery';
                tajexotica_filter_by_select(grid_offers, filterselect_of, item_block_of);
            }
        }

        // Video. Run Only if have any video
        if (jQuery('.container-slideshow .play-video').length) {
            tajexotica_start_video();
            tajexotica_check_stop();
        }

        tajexotica_appear_onscroll(); // Careful with the image sizes
        tajexotica_page_header_animation(); // On Slider Init to send the clone text
        tajexotica_scrollingblocks(); // Hub Animation Blocks
        tajexotica_intersectionRefresh(); // Bug with size of block, add class intersection-reload-scrollto
        // tajexotica_background_main_animation();

        // Clicks functions
        tajexotica_openMenu();
        tajexotica_more_link_menu('#sidebar_menu');
        if (!isTmpHomepage) {
            // Called after. Web Core Vitals
            tajexotica_scroll_top_progress(); // Scroll to top progress
        }
        tajexotica_scrollToElement(); // Scroll to Element
        // ------------------------ //

        // General functions
        tajexotica_hover_ios()
        // ------------------------ //

        // Load Instagram Everywhere (Homepage, default, etc..)
        // Check inside the function
        tajexotica_instagram_lazy();

        // MenuModo Lazy
        tajexotica_menumodolazy();

        // Google Map Lazy with IO. Control Inside
        tajexotica_google_map_lazy(api_key, language);
        tajexotica_tripadvisor_lazy();
        tajexotica_open_block();
        tajexotica_submit_scrolltrigger();
        tajexotica_form_terms();

        if (is_mobile) {
            tajexotica_fix_keyboard_gf();
        }

        // tajexotica_calendar_click();

        //TRACKING
        tajexotica_form_sumbission_tack();
    });

    function tajexotica_headerPosition() {
        var header = $('.container-full-menu');
        // var slideshowHeight = $('#slideshow').height() - 150 // Reduce to start first;
        // var menuHeight = $('.container-menu').height(); // For header without slideshow
        var menuHeight = $('.container-header-fixed').height(); // For header without slideshow

        if (header.length > 0) {
            var scroll = $(window).scrollTop();
            // console.log(scroll)

            if (bodySelectCheck.classList.contains('header-background-sticky')) {
                if (scroll > menuHeight) {
                    bodySelectCheck.classList.add('fixed-header');
                } else {
                    bodySelectCheck.classList.remove('fixed-header');
                }
            } else {
                if (scroll > 300) {
                    bodySelectCheck.classList.add('fixed-header');
                } else {
                    bodySelectCheck.classList.remove('fixed-header');
                }
            }


        }


    }

    function tajexotica_scrollToElement() {
        $('a[href^="#"]')
            .on("click", function () {
                var target = this.hash;
                var $offset = $(".container-menu").height() + 20;
                // offset is 80 then add 20.

                if (!is_mobile) { // Not for mobile devices!
                    if ($("body").hasClass("enable-smooth-scroll")) {

                        window.smoother.scrollTo($(target), true, "top 80px"); // or center center.. the last number is the offset

                    } else {
                        var topY = $(target).offset().top - $("body").offset().top - $offset;
                        $("html,body").animate({scrollTop: topY}, 800);
                    }
                } else {
                    var topY = $(target).offset().top - $("body").offset().top - $offset;
                    $("html,body").animate({scrollTop: topY}, 800);
                }
                return false;
            });
    }

    function tajexotica_scroll_top_progress() {

        // Progress
        var backTopProgress = document.querySelector('.container-progress-wrap path');
        var pathLength = backTopProgress.getTotalLength();
        // backTopProgress.style.transition = backTopProgress.style.WebkitTransition = 'none'; // Transition in css
        backTopProgress.style.strokeDasharray = pathLength + ' ' + pathLength;
        backTopProgress.style.strokeDashoffset = pathLength;
        backTopProgress.getBoundingClientRect();
        // backTopProgress.style.transition = backTopProgress.style.WebkitTransition = 'stroke-dashoffset 10ms linear';  // Transition in css
        var updateProgress = function () {
            var scroll = $(window).scrollTop();
            var height = $(document).height() - $(window).height();
            var progress = pathLength - (scroll * pathLength / height);
            backTopProgress.style.strokeDashoffset = progress;
        }
        updateProgress();
        // $(window).scroll(updateProgress);
        var offset = 500; // When start
        var duration = 1000; // Animation duration

        // Performance Improvement
        window.addEventListener('scroll', tajexotica_throttle(updateProgress, 10));
        window.addEventListener('scroll', tajexotica_throttle(changeClassScrollTop, 30));

        // Show Scroll To Top
        // jQuery(window).on('scroll', function () {
        //     if (jQuery(this).scrollTop() > offset) {
        //         jQuery('.container-progress-wrap').addClass('active-progress');
        //     } else {
        //         jQuery('.container-progress-wrap').removeClass('active-progress');
        //     }
        // });

        function changeClassScrollTop() {
            if (jQuery(this).scrollTop() > offset) {
                jQuery('.container-progress-wrap').addClass('active-progress');
            } else {
                jQuery('.container-progress-wrap').removeClass('active-progress');
            }
        }

        // Click Scroll To Top
        jQuery('.container-progress-wrap').on('click', function (event) {
            event.preventDefault();
            // window.smoother.scrollTo("#scroll-container", true); // Not for mobile devices
            $("html,body").animate({scrollTop: 0}, duration);
            return false;
        })
    }

    /////////////// ==== General Functions Start ==== ///////////////

    function tajexotica_throttle(callback, limit) {
        var waiting = false;
        return function () {
            if (!waiting) {
                callback.call();
                waiting = true;
                setTimeout(function () {
                    waiting = false;
                }, limit);
            }
        }
    }

    // Check if Script exists
    function check_if_exists_js(src) {
        var scripts = document.getElementsByTagName("script");
        // Check without script ID. Only link
        for (var i = 0; i < scripts.length; i++)
            if (scripts[i].getAttribute('src') === src) return true;
        return false;
    }

    function tajexotica_test_get_height_width_empty() {
        // console.time('checktimer');
        var start = window.performance.now();
        var allImages = jQuery('img');

        function imgCheck(attributeOne, attributeTwo, attributeThree) {
            allImages.each(function () {
                var $this = jQuery(this);
                if (!$this.attr(attributeOne) || !$this.attr(attributeTwo) || !$this.attr(attributeThree)) {
                    console.log('Missing:')
                    console.log($this[0]);
                }
            });

        };

        // Wait 15 seconds to check for new images, and scroll always to the footer
        function checkImages() {
            imgCheck('width', 'height', 'alt');
            setTimeout(checkImages, 15000);
            console.log('>>> Run Control Images');
        }

        // Check time

        checkImages();
        // console.timeEnd('checktimer');
        var end = window.performance.now();
        var time = end - start;
        console.log('Took', time.toFixed(4), 'ms to Generate');

    }

    // tajexotica_test_get_height_width_empty();

    function tajexotica_hover_ios() {
        // Hover fix for iOS
        // ==================
        $("*").on("touchstart", function () {
            $(this).trigger("hover");
        }).on("touchend", function () {
            $(this).trigger("hover");
        });
    }

    /////////////// ==== General Functions End ==== ///////////////


    /////////////// ==== Load Start ==== ///////////////

    function tajexotica_load_fonts() {
        if (isTmpHomepage) {
            if (!sessionStorage.fontsLoaded) {
                // Needs to load the font if not the FontFaceObserver won't work
                loadCSS_fast(theme_url + current_hotel['font_file'], 'fonts_preloaded');

                // Load all to use in the Hmp
                var aboveHeaderMain, aboveFontMain;
                // var belowFontMain, secondFontMain;

                aboveHeaderMain = new FontFaceObserver('Calibri-Regular');
                aboveFontMain = new FontFaceObserver('Calibri-Light');
                // aboveHeaderMain = new FontFaceObserver('Sun-Regular');
                // aboveFontMain = new FontFaceObserver('Sun-ExtraLight');
                // belowFontMain = new FontFaceObserver('Sun-SemiBold');
                // secondFontMain = new FontFaceObserver('TrajanPro-Regular'); // Check if is used

                if (rusCheck) {
                    loadCSS_fast(theme_url + current_hotel['font_rus_file'], 'fonts_preloaded');
                    aboveHeaderMain = new FontFaceObserver('OpenSans-Regular');
                    aboveFontMain = new FontFaceObserver('OpenSans-Light');
                }

                // Only the main fonts, the rest is loaded with the loadCSS_fast
                async function tajexotica_await_fonts_main() {
                    return await Promise.all([
                        aboveHeaderMain.load(),
                        aboveFontMain.load(),
                        // belowFontMain.load(),
                        // secondFontMain.load(),
                    ])
                }

                tajexotica_await_fonts_main().then(function () {
                    document.documentElement.classList.add('fonts-loaded');
                    sessionStorage.fontsLoaded = true;
                }).catch(e => {

                    // Added the catch error, sometimes the font is not loading. More than 3000ms
                    // If you want more time to load the font load(null, 5000) by default is 3000
                    console.log('There has been a problem with the fonts: ' + e.message);

                }).finally(function () {
                    document.documentElement.classList.add('fonts-loaded');
                });
                // setTimeout(function () {
                //     html_tag.classList.add('fonts-loaded');
                //     sessionStorage.fontsLoaded = true;
                // }, 0); // Avoid fonts moving while loading. Don't increase
            }
        }
    }

    function tajexotica_ewdelay_or_interaction_js() {
        if (is_mobile) {
            var timeToLoad = sessionStorage.fontsLoaded ? 1000 : 3500;
        } else {
            // For the second load from ps (passing from Mobile to Desktop)
            // var timeToLoad = sessionStorage.fontsLoaded ? 3000 : 3500;
            var timeToLoad = 3500;
        }

        // var timeToLoad = 3000;
        tajexotica_fullwidth_slideshow = tajexotica_call_once(tajexotica_fullwidth_slideshow);
        tajexotica_fancybox_popup = tajexotica_call_once(tajexotica_fancybox_popup);
        functions_to_run_homepage = tajexotica_call_once(functions_to_run_homepage);

        function functions_to_run_homepage() {
            if (isTmpHomepage) {
                // Don't need the call once, the clearTimeout is solving the double call
                setTimeout(function () {
                    tajexotica_fancybox_popup();
                    tajexotica_fullwidth_slideshow();
                    tajexotica_slider_full();
                    tajexotica_slider_small();
                    tajexotica_slider_filter();
                    // tajexotica_fancybox_callback(); // Not using
                    tajexotica_icons(); // Moved here not everywhere to avoid flashing
                    tajexotica_scroll_top_progress();
                }, 1000); // Don't change 1500 or won't run
            }
        }

        var ewDelayTimer = setTimeout(function () {
            ewLoadDelayedScripts();
            ewTriggerAssets();
            functions_to_run_homepage();
            // tajexotica_load_fonts(); // Enabled after?. Using second-round
        }, timeToLoad); // Nothing change, before 3000

        var ewDelaySmall = setTimeout(function () {
            if (is_mobile && isTmpHomepage) {
                tajexotica_prog_slideshow(); // Ok. Run Once Check running. Prog Slideshow Mobile if is running twice
            }
        }, timeToLoad); // Can't be less of 3000

        var ewUserInteractions = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
        ewUserInteractions.forEach(function (event) {
            window.addEventListener(event, ewTriggerDelayedScripts, {passive: !0})
        });

        function ewTriggerDelayedScripts() {

            ewLoadDelayedScripts();
            ewTriggerAssets();
            // With the next rule can use slider with Lazy. Must use settimeout
            // Also needs to finish the fade animation (progressive img) before slick loads, for that 1200
            // If no the fade progressive image will load twice

            functions_to_run_homepage();
            // tajexotica_swiper_fullwidth_lazy();

            if (is_mobile && isTmpHomepage) {
                tajexotica_prog_slideshow();  // Ok. Run Once Check running TajExotica Prog Slideshow Mobile if is running twice
            }

            tajexotica_load_fonts();
            // Run everywhere. Not Only Homepage
            // tajexotica_cookiesBanner(); // Deprecated
            // tajexotica_booking();

            if (!isTmpHomepage) {
                tajexotica_icons();
            }

            clearTimeout(ewDelayTimer);
            clearTimeout(ewDelaySmall);
            ewUserInteractions.forEach(function (event) {
                window.removeEventListener(event, ewTriggerDelayedScripts, {passive: !0});
            });
        }

        function ewTriggerAssets() {
            var lazy_selected_imgs = Array.from(document.querySelectorAll('.lazy_ew_img'));
            if (lazy_selected_imgs != null) {
                lazy_selected_imgs.forEach(image => {
                    // Avoid changing the src twice
                    if (!image.classList.contains('loaded')) {
                        image.setAttribute('src', image.getAttribute('data-src'));
                        image.classList.add('loaded');
                    }
                })
            }

            // Before was lazy_ew
            var lazy_selected_bgs = Array.from(document.querySelectorAll('.lazy_ew_bg'));
            if (lazy_selected_bgs != null) {
                lazy_selected_bgs.forEach(image => {
                    if (image.getAttribute('data-style') != null) {
                        image.setAttribute('style', image.getAttribute('data-style'));
                        image.removeAttribute('data-style');
                    }
                })
            }

            // Lazy Load iFrame WYSIWYG
            var lazy_selected_iframes = Array.from(document.querySelectorAll('.wysiwyg-container iframe[data-src]'));
            if (lazy_selected_iframes != null) {
                lazy_selected_iframes.forEach(iframeLazy => {
                    if (iframeLazy.getAttribute('data-src') != null) {
                        iframeLazy.setAttribute('src', iframeLazy.getAttribute('data-src'));
                        iframeLazy.removeAttribute('data-src');
                    }
                })
            }

        }

        function ewLoadDelayedScripts() {
            document.querySelectorAll("script[data-ewdelayedscript]").forEach(function (elem) {
                    elem.setAttribute("src", elem.getAttribute("data-ewdelayedscript"));
                    // Optional remove the last attribute data-ewdelayedscript
                    elem.removeAttribute("data-ewdelayedscript");
                }
            );
        }

        function tajexotica_cookiesBanner() {
            var cookieScript = document.getElementById("de-macaron-script");
            if (cookieScript != null) {
                // console.log(cookieScript)
                var cookieLink = 'https://dedge-cookies.web.app/decookie.min.js';
                var cookieFile = theme_url + '/assets/lightbox.min.js';
                cookieScript.src = cookieScript.src.replace(cookieFile, cookieLink)
                loadjs(cookieScript.src, { // Also with ?ver=..
                    success: function () {
                        console.log('Cookies Intersected')
                    }
                });
            }
        }
    }

    // LazyLoad with IntersectionObserver
    function tajexotica_lazy_load_img(images_sliders) {
        var images = (images_sliders != null) ? images_sliders : Array.from(document.querySelectorAll('.lazy_img'))

        if (images != null) {
            if (iObserver) {
                setupIntersectionObserver(images);
            } else {
                loadImages(images);
            }
        }

        function setupIntersectionObserver(images) {
            var options = {
                root: rootIO,
                rootMargin: '50px 50px 50px 50px',
                threshold: 0
            };

            var observer = new IntersectionObserver(onIntersection, options);
            images.forEach(image => observer.observe(image));
        }

        function onIntersection(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    observer.unobserve(entry.target);
                    loadImage(entry.target);
                }
            });
        }

        function loadImage(image) {
            // Delete the check src for the src aspect ratio blank (solved with loaded)
            if (!image.classList.contains('loaded') && !image.classList.contains('swiper-lazy')) {
                image.setAttribute('src', image.getAttribute('data-src'));
                image.classList.add('loaded');
                // Problems with empty blank sliders that gives null to src (solved with loaded)
                // image.onload = () => image.removeAttribute('data-src');
            }
        }

        function loadImages(images) {
            images.forEach(loadImage);
        }
    }

    function tajexotica_icons() {
        loadCSS_fast('//staticaws.fbwebprogram.com/FBServicesWebfonts/css/services_webfont.css', 'icons_css');

        // if (isTmpHomepage) {
        bodySelectCheck.classList.add('icons-loaded') // Avoid showing while is loading
        // }
    }

    // LazyLoad for Google Map
    function tajexotica_google_map_lazy(key, language) {
        var map = document.getElementById('map');
        const target_map_always = document.getElementById('first-block-below');
        var backUpTargetBottom = document.querySelector('[data-observer="finish-observer-second"]');
        if (map != null) {
            ;(function ($) {
                function loadGoogleLazy() {

                    var linkURLGoogle = theme_url + '/js/map-google.min.js';

                    loadjs(linkURLGoogle, {
                        success: function () {
                            // It gives error if is local
                            loadjs('//maps.google.com/maps/api/js?key=' + key + '&callback=intializedMap&v=3&libraries=places&language=' + language)
                            console.log('Google Map Intersected')
                        }
                    });
                }

                if (iObserver) {

                    var optionsMap = {
                        root: rootIO,
                        // rootMargin: '200px 0px 200px 0px',
                        rootMargin: '0px 0px -500px 0px',
                        // threshold: 0.01
                        threshold: 1
                    };

                    var observer = new IntersectionObserver(
                        function (entries, observer) {
                            var isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
                            if (isIntersecting) {
                                loadGoogleLazy();
                                // if (target_map != null) {
                                //     observer.unobserve(target_map);
                                // } else {
                                //     observer.unobserve(target_map_always);
                                // }
                                observer.unobserve(backUpTargetBottom);
                                observer.unobserve(target_map_always);
                            }
                        },
                        optionsMap
                    );

                    // if (target_map != null) {
                    //     observer.observe(target_map);
                    // } else {
                    //     // To use also on the default page
                    //     observer.observe(target_map_always);
                    // }
                    observer.observe(backUpTargetBottom);
                    observer.observe(target_map_always);


                } else {
                    loadGoogleLazy()
                }

            })(jQuery);
        }

    }

    function tajexotica_instagram_lazy() {
        // Loaded in Ultra-Speed. Second Option:
        ;(function ($) {
            var instagram_feeds_block = document.getElementById('container-instagram');
            const target_instagram_always = document.getElementById('first-block-below');
            var backUpTargetBottom = document.querySelector('[data-observer="finish-observer-second"]');
            if (instagram_feeds_block != null) {

                function loadInstagramLazy() {
                    var loadBefore;
                    if (isTmpHomepage) {
                        loadBefore = 'style-homepage-css';
                    } else {
                        loadBefore = 'style-main-css';
                    }

                    loadCSS_fast(website_url + '/wp-content/plugins/instagram-feed-pro/css/sb-instagram.min.css', 'instagram_css', loadBefore)
                    // }
                    $('#container-instagram').append(JSON.parse($('#instagram_data').text()));

                    if (typeof sbi_init != 'undefined') {
                        sbi_init();
                    }

                    // Refresh ScrollTrigger
                    setTimeout(function () {
                        ScrollTrigger.refresh(true);
                    }, 500);

                    console.log('Instagram Widget Intersected');
                }

                if (iObserver) {
                    // var instagram_feeds = document.querySelector('.targetInstagram');

                    var options = {
                        // root: null,
                        root: rootIO,
                        // rootMargin: '600px 0px 600px 0px',
                        rootMargin: '0px 0px -500px 0px',
                        // rootMargin: '600px 0px 600px 0px',
                        //threshold size in % of the image that need to read to start the lazy loading
                        // threshold: 0.01
                        threshold: 1
                    };

                    var observer = new IntersectionObserver(
                        function (entries, observer) {
                            var isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
                            if (isIntersecting) {
                                loadInstagramLazy();

                                // if (instagram_feeds_target_two != null) {
                                //     observer.unobserve(instagram_feeds_target_two);
                                // } else {
                                //     // To use also on the default page
                                //     observer.unobserve(target_instagram_always);
                                // }
                                observer.unobserve(backUpTargetBottom);
                                observer.unobserve(target_instagram_always);
                            }
                        },
                        options
                    );

                    // if (instagram_feeds_target_two != null) {
                    //     observer.observe(instagram_feeds_target_two);
                    // } else {
                    //     // To use also on the default page
                    //     observer.observe(target_instagram_always);
                    // }
                    observer.observe(backUpTargetBottom);
                    observer.observe(target_instagram_always);


                } else {
                    loadInstagramLazy()
                }

            }
        })(jQuery);
    }

    // LazyLoad for TripAdvisor
    function tajexotica_tripadvisor_lazy() {
        var tripAdivosrBlock = document.getElementById('tripadvisor-block-reviews');
        const target_tripadvisor_always = document.getElementById('first-block-below');
        var backUpTargetBottom = document.querySelector('[data-observer="finish-observer-second"]');
        if (tripAdivosrBlock != null) {
            ;(function ($) {
                function loadTripAdvisorLazy() {

                    var tripLoaded = false;
                    if (!tripLoaded) {
                        $.getScript('//www.jscache.com/wejs?wtype=selfserveprop&uniq=801&locationId=23843020&lang=' + lang_code + '&rating=true&nreviews=0&writereviewlink=true&popIdx=true&iswide=true&border=false&display_version=2', function () {
                            tripLoaded = true;
                            var waitforTa = setInterval(function () { // Waitout the setInterval is not working
                                if (typeof taValidate !== 'undefined') {
                                    taValidate();
                                    // setTimeout(function () {
                                    ScrollTrigger.refresh(true);
                                    // }, 500);
                                    console.log('Loaded TripAdvisor Lazy');
                                    clearInterval(waitforTa);
                                }
                            }, 300);
                        });
                    }
                }

                if (iObserver) {

                    var optionsIO = {
                        root: rootIO,
                        // rootMargin: '1200px 0px 1200px 0px', // Add more space for the SetInterval 500
                        rootMargin: '0px 0px -500px 0px', // Add more space for the SetInterval 500
                        // threshold: 0.01
                        threshold: 1
                    };

                    var observer = new IntersectionObserver(
                        function (entries, observer) {
                            var isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
                            if (isIntersecting) {
                                loadTripAdvisorLazy();
                                observer.unobserve(target_tripadvisor_always);
                                observer.unobserve(backUpTargetBottom);
                            }
                        },
                        optionsIO
                    );

                    observer.observe(target_tripadvisor_always);
                    observer.observe(backUpTargetBottom);

                } else {
                    loadTripAdvisorLazy()
                }

            })(jQuery);
        }

    }

    // Don't use the native Swiper Lazy, is not changing the srcset
    function tajexotica_swiper_fullwidth_lazy() {
        ;(function ($) {
            var swiper_fullwidth = jQuery('.container-slideshow-block');
            if (swiper_fullwidth.length > 0) {
                // Second function Ultra Speed, load after X seconds and mouse move all the sliders. Max 4 in ACF
                setTimeout(function () {
                    document.addEventListener('mousemove', loadSwiperMouse);
                    // Passive flag true to dont preventDefault improve performance
                    document.addEventListener('touchstart', loadSwiperMouse, {passive: true});
                    var nextSlidersImg = jQuery('.container-slideshow-block .swiper-slide');

                    function sliderImages(el, attr, lazyAttr) {
                        nextSlidersImg
                            .find(el)
                            .each(function (i, img) {
                                $img = $(img);
                                $img.attr(attr, $img.data(lazyAttr));
                                // Add loaded for opacity and remove the div for swiper preload
                                $img.addClass('loaded');
                                jQuery('.slideshow-main .swiper-lazy-preloader').remove(); // Delete if is also picture source.. is not the next element
                            });
                        document.removeEventListener('mousemove', loadSwiperMouse);
                        document.removeEventListener('touchstart', loadSwiperMouse);
                    };

                    function loadSwiperMouse() {
                        sliderImages('picture source[data-srcset]', 'srcset', '-srcset');
                        sliderImages('img[data-src]', 'src', 'src');
                    }

                }, 500); // Was 1500. It already have some time in corvaia_ewdelay_or_interaction_js. Is to wait finishing the swiper and the clones
            }
        })(jQuery);
    }

    /////////////// ==== Load End ==== ///////////////


    /////////////// ==== Video Start ==== ///////////////

    function play_video() {
        if (playerRun === null) {
            window.console && console.log('Player not initialized yet');
            return;
        }
        showVideo();
        // if(autoplayVideo) {
        //     playerRun.muted = true; // Autoplay should be muted. Is added in the config
        // }
        playerRun.play();

        // Playing Full Video
        // var rootClass = document.querySelector(':root');
        document.getElementsByTagName("html")[0].classList.toggle('playing-video-full');

        // Playing Full Video
        if (jQuery('.slideshow-reduced').length > 0) {
            // Refresh ScrollTrigger
            setTimeout(function () {
                ScrollTrigger.refresh(true);
            }, 500);
        }

        slideShowMain.autoplay.stop();
        window.effectSliderParallax.scrollTrigger.disable(); // Parallax bg movements on the bottom
        // Stop only the parallax from the slider
    }

    function showVideo() {
        console.log('Playing added')
        var containerSlideshow = jQuery('.container-slideshow');
        containerSlideshow.addClass('playing');

        // Pause the video clicking, without showing the Vimeo YouTube Play 'play-large', clickToPlay: false,
        jQuery('.plyr__video-wrapper').on('click', function (e) {
            e.preventDefault();
            playerRun.pause();
        })
    }

    function hideVideo() {
        // Playing Full Video
        // var rootClass = document.querySelector(':root');
        // rootClass.classList.toggle('playing-video-full');
        document.documentElement.style.setProperty('--height-animation-speed', '0s'); // To avoid slow animation when change the slider
        document.getElementsByTagName("html")[0].classList.toggle('playing-video-full');

        // To avoid slow animation when change the slider
        setTimeout(function () {
            document.documentElement.style.setProperty('--height-animation-speed', heightAnimSpeed);
        }, 500)

        var containerSlideshow = jQuery('.container-slideshow');
        containerSlideshow.removeClass('playing').removeAttr('style');
        jQuery('.video-wrapper').children().remove(); // Added the remove to have more videos
        if (slideShowMain.autoplay.running) {
            // Check if have autoplay. 0 is false
            slideShowMain.autoplay.start();
            // Need the time.. So if you play and stop video the autoplay won't work after. Fix: Added swiper-slide data-swiper-autoplay
        }

        if (isTmpHomepage && jQuery('.container-video-progress-wrap').length > 0 && !is_mobile) {
            jQuery('#svg_progress_container').remove();
            jQuery('.marker_position_holder').remove();
            // jQuery('.container-video-progress-wrap').remove()
        }
        window.playerRun = null; // Destroy

        // Playing Full Video
        if (jQuery('.slideshow-reduced').length > 0) {
            // Refresh ScrollTrigger
            setTimeout(function () {
                ScrollTrigger.refresh(true);
            }, 500);
        }

        window.effectSliderParallax.scrollTrigger.enable(); // Parallax bg movements
    }

    function tajexotica_create_progress_controllers() {
        var radiusCircle = 48.5;
        var circleCX = radiusCircle + 1.5;
        var circleCY = circleCX;
        var circCircle = 2 * Math.PI * radiusCircle;
        window.circleSVGRoute = SVG().addTo('#progress_container').attr({
            'viewBox': '-5 -5 110 110',
            'width': '200px',
            'id': 'svg_progress_container'
        });

        circleSVGRoute.circle().attr({
            'r': radiusCircle,
            'cx': circleCX,
            'cy': circleCY,
            'class': 'progressbar-back'
        });

        var progressLineBarVideo = circleSVGRoute.circle().attr({
            'r': radiusCircle,
            'cx': circleCX,
            'cy': circleCY,
            'stroke-dasharray': circCircle + ' ' + circCircle,
            'stroke-dashoffset': circCircle,
            'class': 'progressbar-line'
        });
    }

    function tajexotica_video_play(video_id, platformVideo) {

        var controls_video = $('.controls .control-video-item');
        var playerMain = jQuery('#player');
        // Added to have more videos
        if (playerMain.length > 0) {
            playerMain.attr({
                'data-plyr-embed-id': video_id,
                'data-plyr-provider': platformVideo
            });
        } else {
            jQuery('.swiper-slide-active .video-wrapper').append('<div id="player" data-plyr-provider="' + platformVideo + '" data-plyr-embed-id="' + video_id + '"></div>');
            // Leave to get a new one. The new added
            // jQuery('#player').attr('data-plyr-embed-id', video_id);
        }
        var error = 0;

        var volumeValue = autoplayVideo && !is_mobile ? 0 : 0.5;
        var muteValue = autoplayVideo && !is_mobile; // Mute for Mobile, never will we AutoPlay
        // console.log(volumeValue + ' ' + muteValue)

        // Video Controller Circle
        var videoProgressWrap = jQuery('.container-video-progress-wrap');

        var controlsPlyr, markersPlyr;
        // console.log(markerPlyrArray)

        if (isTmpHomepage && videoProgressWrap.length > 0 && !is_mobile) {
            controlsPlyr = [
                // 'play-large', // The large play button in the center
                'restart', // Restart playback
                'rewind', // Rewind by the seek time (default 10 seconds)
                'play', // Play/pause playback
                'fast-forward', // Fast forward by the seek time (default 10 seconds)
                'progress', // The progress bar and scrubber for playback and buffering
                'current-time', // The current time of playback
                'duration', // The full duration of the media
                'mute', // Toggle mute
                'volume', // Volume control
                'captions', // Toggle captions
                'settings', // Settings menu
                'pip', // Picture-in-picture (currently Safari only)
                'airplay', // Airplay (currently Safari only)
                // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
                'fullscreen', // Toggle fullscreen
            ]

            markersPlyr = {
                enabled: true,
                points: markerPlyrArray
            };
        } else if (!is_mobile) {

            controlsPlyr = [
                // 'play-large', // The large play button in the center
                'restart', // Restart playback
                'rewind', // Rewind by the seek time (default 10 seconds)
                'play', // Play/pause playback
                'fast-forward', // Fast forward by the seek time (default 10 seconds)
                'progress', // The progress bar and scrubber for playback and buffering
                'current-time', // The current time of playback
                'duration', // The full duration of the media
                'mute', // Toggle mute
                'volume', // Volume control
                'captions', // Toggle captions
                'settings', // Settings menu
                'pip', // Picture-in-picture (currently Safari only)
                'airplay', // Airplay (currently Safari only)
                // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
                'fullscreen', // Toggle fullscreen
            ]

            markersPlyr = {
                enabled: false
            };

        } else {

            controlsPlyr = [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'captions',
                'airplay',
                'fullscreen'
            ]
            markersPlyr = {
                enabled: false
            };
        }


        window.playerRun = new Plyr('#player', {
            muted: muteValue, // Autoplay should be muted
            controls: controlsPlyr,
            // quality: {
            //     default: 'auto',
            // },
            markers: markersPlyr,
            storage: {
                enabled: false, // Is saving the muted in false.. and needs to change the name
                key: 'plyr'
            },
            volume: volumeValue,
            clickToPlay: false,
            // keyboard https://github.com/sampotts/plyr#shortcuts
            // debug: true,
            // Using my own svg
            loadSprite: false,
            invertTime: false, // Invert time
            iconUrl: theme_url + '/assets/plyr.svg',
        });

        if (isTmpHomepage && jQuery('.container-video-progress-wrap').length > 0 && !is_mobile) {
            tajexotica_create_progress_controllers();
            window.progressVideo = document.querySelector('.progressbar-line');
            window.progressLength = progressVideo.getTotalLength()
        }


        playerRun.on('ready', function () {
            play_video();

            if (isTmpHomepage && videoProgressWrap.length > 0 && !is_mobile) {

                setTimeout(function () {
                    if (playerRun != null) {
                        // Started before by default
                        // progressVideo.style.strokeDasharray = progressLength + ' ' + progressLength;
                        // progressVideo.style.strokeDashoffset = progressLength;
                        // progressVideo.getBoundingClientRect();

                        for (var j = 0; j < playerRun.config.markers.points.length; j++) {
                            tajexotica_draw_circle(playerRun.config.markers.points[j].time, playerRun.duration, j);
                            tajexotica_draw_chapter(playerRun.config.markers.points[j].time, playerRun.duration, playerRun.config.markers.points[j].label, j);
                        }

                        jQuery('.progressbar-marker').each(function () {
                            $(this).on('mouseenter', function () {
                                var hoverCircle = $(this).data('hover-circle');
                                jQuery('.marker_position_holder[data-hover-circle="' + hoverCircle + '"]').addClass('marker_hovered');
                            })

                            $(this).on('mouseleave', function () {
                                var hoverCircle = $(this).data('hover-circle');
                                jQuery('.marker_position_holder[data-hover-circle="' + hoverCircle + '"]').removeClass('marker_hovered');
                            })
                        });

                    }
                }, 1500) // Vimeo needs some time to calculate the duration
            }

        });

        if (isTmpHomepage && videoProgressWrap.length > 0 && !is_mobile) {
            // Performance with throttle
            playerRun.on('timeupdate', tajexotica_throttle(function (e) {
                // The e won't work
                var actualProgress = progressLength - (playerRun.currentTime * progressLength / playerRun.duration);
                progressVideo.style.strokeDashoffset = actualProgress;
                for (var j = 0; j < playerRun.config.markers.points.length; j++) {
                    if (playerRun.currentTime > playerRun.config.markers.points[j].time && playerRun.currentTime <= playerRun.config.markers.points[j].time + 5) {
                        var markerPositionHolder = jQuery('.marker_position_holder[data-hover-circle="' + j + '"]')
                        markerPositionHolder.addClass('start-new-marker');
                        setTimeout(function () {
                            markerPositionHolder.removeClass('start-new-marker')
                        }, 2000)
                    }
                }
            }, 100));
        }

        // Fix IOS + chrome on youtube - play doesn't work with this combo. So we just remove the slideshow layer on click.
        // Fix it would require to drop the video load on click hugely worsening the page speed (about 15mb more).
        // https://www.zdnet.com/article/which-browser-is-most-popular-on-each-major-operating-system/

        // Enabling this everywhere like Chrome + Window + youtube play and stop can't play again.. So only for iOS
        var isIOS = /iPad|iPhone|iPod/.test(navigator.platform);
        if (isIOS) {
            playerRun.on('statechange', function (e) {
                var eventCode = e.detail.code;
                // we have two event code -1 (unstarted) only when the browser consider illegitimate the video play (detected as "auto play")
                // more info https://developers.google.com/youtube/iframe_api_reference
                if (eventCode === -1) {
                    error++;
                    if (error > 1) {
                        playerRun.pause();
                    }
                }
            });
        }

        playerRun.on('ended', function () {
            // playerRun.stop();
            // hideVideo();
            // Restart instead of stop
            playerRun.restart();
        });

        if (controls_video.length > 0) {
            controls_video.on('click', function () {
                if ($(this).hasClass('mute')) {
                    playerRun.muted = false;
                    playerRun.volume = 0.5;
                    $(this).removeClass('mute').addClass('volumeok');
                    // } else if ($(this).hasClass('volumeok')) {
                    //     playerRun.muted = false;
                    //     $(this).removeClass('volumeok').addClass('mute');
                }
            });
        }

    }

    function tajexotica_draw_chapter(seconds, duration, label, index) {
        var percent = (seconds * 100) / duration;
        var position = tajexotica_coordinates_points(percent);
        var leftMarkerSide = '';
        if (seconds > duration / 2) {
            leftMarkerSide = 'add_left_holder'
        }

        var triggerMarker = $('<div/>', {'class': 'marker_position_holder ' + leftMarkerSide})
        triggerMarker.text(label)
        jQuery('.container-video-progress-wrap').append(triggerMarker);
        triggerMarker.css({
            'left': position[0] + '%',
            'bottom': position[1] + '%'
        }).attr({'data-hover-circle': index});
    }

    function tajexotica_draw_circle(time, duration, index) {
        var rotation = (time * 360) / duration;
        var circleMarker = circleSVGRoute.circle().attr({
            'r': '6',
            'cx': '50',
            'cy': '1.5',
            'class': 'progressbar-marker',
            'data-hover-circle': index
        }).css({
            'transform': 'rotate(' + rotation + 'deg)'
        });

        circleMarker.on('click', function () {
            playerRun.currentTime = time;
        });
    }

    function tajexotica_coordinates_points(percent) {
        // Explenation: https://math.stackexchange.com/questions/332743/calculating-the-coordinates-of-a-point-on-a-circles-circumference-from-the-radiu
        var angle = (percent * 360) / 100;
        var xp1 = 0.5;
        var yp1 = 1;
        var r = 0.48;
        var xp2 = xp1 + r * (Math.sin(tajexotica_degrees_to_radians(angle)));
        var yp2 = yp1 - r * (1 - Math.cos(tajexotica_degrees_to_radians(angle)));
        return [xp2 * 100, yp2 * 100]
    }

    function tajexotica_degrees_to_radians(degrees) {
        var pi = Math.PI;
        return degrees * (pi / 180);
    }

    function tajexotica_start_video() {
        jQuery('.container-slideshow .play-video').each(function () {
            var playerItem = $(this);
            var platformVideo = $(this).data('provider');
            var video_id = playerItem.data('video-id');
            playerItem.on('click', function (e) {
                e.preventDefault();
                tajexotica_video_play(video_id, platformVideo);
            });
        });
    }

    function tajexotica_check_stop() {
        if (iObserver) {
            const firstBlockControl = document.getElementById('first-block-below')
            if (firstBlockControl != null) {

                var options = {
                    root: rootIO,
                    rootMargin: '0px 0px -700px 0px',
                    threshold: 1.0
                };

                function destroyVideo() {
                    window.playerRun.destroy();
                    hideVideo();
                    // Don't unobserve
                    // observer.unobserve(firstBlockControl);
                }

                function checkPausedVideo() {
                    // Run just once, because after is destroyed paused is null
                    // Only works if is paused on the first time. Don't work if play go down stop, and play and stop go down (Very specific case..)
                    checkPausedVideo = function () {
                    };
                    if (window.playerRun.paused) {
                        console.log('Destroy paused Video');
                        destroyVideo()
                    }
                }

                var observer = new IntersectionObserver(
                    function (entries, observer) {
                        if (entries[0].isIntersecting) {
                            if (window.playerRun != null) {

                                checkPausedVideo();
                                if (window.playerRun.playing != null) {
                                    console.log('Stop Video');
                                    destroyVideo();
                                }

                            }
                        }
                    },
                    options
                );

                observer.observe(firstBlockControl);

            }
        }
    }

    /////////////// ==== Video End ==== ///////////////


    /////////////// ==== Sliders Start ==== ///////////////

    // Fullwidth Slider
    function tajexotica_fullwidth_slideshow() {

        if (typeof Swiper !== 'undefined') {
            // Slideshow
            var checkSlideshow = jQuery('.container-slideshow .swiper-slide');
            if (checkSlideshow.length) {
                var renderSliderBullets = function (index, className) {
                    return '<span class="' + className + ' swiper-pagination-bullet--svg-animation">' +
                        '<svg width="26" height="26" viewBox="0 0 28 28">' +
                        '<circle class="svg__circle" cx="14" cy="14" r="12" fill="none" stroke-width="2">' +
                        '</circle>' +
                        '<circle class="svg__circle-inner" cx="14" cy="14" r="6" stroke-width="3">' +
                        '</circle>' +
                        '</svg>' +
                        '</span>';
                }

                // Is moved here so when stop the video and start again the sliders have their speed
                // This is a native swiper function data-swiper-autoplay in the swiper-slide
                var autoPlayValue = jQuery('.slideshow-main .swiper-slide').data("swiper-autoplay")

                var $autoplay = autoPlayValue ? {
                    delay: autoPlayValue,
                    disableOnInteraction: false
                } : autoPlayValue;

                window.slideShowMain = new Swiper(".slideshow-main", {
                    // lazy: false,
                    lazy: {
                        // Instead of swiper lazy fullwidth function
                        loadPrevNext: true,
                        loadOnTransitionStart: true, // Start loading before pressing the next slide
                        loadPrevNextAmount: 2
                    },
                    loop: false, // check Needs to resend the text for the animation
                    parallax: true,
                    longSwipesRatio: 0.3, // Grab to move to next/prev slide
                    grabCursor: true,
                    speed: 1000,
                    autoplay: $autoplay,
                    resistanceRatio: 0,
                    preventInteractionOnTransition: true, // No actions during transition
                    pagination: {
                        el: ".container-slideshow .bullets-pagination",
                        modifierClass: "bullets-pagination-",
                        dynamicBullets: false, // It will keep only few bullets visible at the same time.
                        dynamicMainBullets: 1, // The number of main bullets visible when dynamicBullets enabled.
                        clickable: true,
                        renderBullet: renderSliderBullets,

                    },
                    navigation: {
                        nextEl: ".container-slideshow .swiper-button-next.swiper-next-border",
                        prevEl: ".container-slideshow .swiper-button-prev.swiper-prev-border",
                    },
                    // Events
                    on: {
                        slideChangeTransitionStart: function () {
                            if (window.playerRun != null) {
                                // Stop the video if is playing and use the navigation
                                // console.log(window.playerRun.playing)
                                if (window.playerRun.playing || window.playerRun.paused) {
                                    console.log('Stop Video')
                                    window.playerRun.destroy();
                                    hideVideo();
                                }
                            }
                            // if (autoplayVideo) {
                            //     // Autoplay on change slide
                            //     var actualSliderVideo = jQuery('#slideshow .swiper-slide-active .play-video');
                            //     tajexotica_autoplay(actualSliderVideo);
                            // }
                        },

                        init: function (swiper) {
                            // If loop is enabled
                            // tajexotica_page_header_animation()
                            // swiper.update();
                        }
                    }
                });

                // Autoplay on load
                if (autoplayVideo && !is_mobile) {
                    var actualSliderVideo = jQuery('#slideshow .swiper-slide-active .play-video');
                    tajexotica_autoplay(actualSliderVideo);
                }

                function tajexotica_autoplay(slideVideo) {
                    if (slideVideo.length > 0) {
                        var platformVideo = slideVideo.data('provider');
                        var video_id = slideVideo.data('video-id');
                        setTimeout(function () {
                            // Added time to load plyr
                            tajexotica_video_play(video_id, platformVideo);
                        }, 0) // First 1000, First 200

                    }
                }

            }
        } else {
            console.log('Too fast.. ');
        }
    }

    // Using the tajexotica_swiper lazy
    // function tajexotica_fullwidth_slideshow() {
    //
    //     if (typeof Swiper !== 'undefined') {
    //         // Slideshow
    //         var checkSlideshow = jQuery('.container-slideshow .swiper-slide');
    //         if (checkSlideshow.length) {
    //             var renderSliderBullets = function (index, className) {
    //                 return '<span class="' + className + ' swiper-pagination-bullet--svg-animation">' +
    //                     '<svg width="26" height="26" viewBox="0 0 28 28">' +
    //                     '<circle class="svg__circle" cx="14" cy="14" r="12" fill="none" stroke-width="2">' +
    //                     '</circle>' +
    //                     '<circle class="svg__circle-inner" cx="14" cy="14" r="6" stroke-width="3">' +
    //                     '</circle>' +
    //                     '</svg>' +
    //                     '</span>';
    //             }
    //
    //             // Is moved here so when stop the video and start again the sliders have their speed
    //             // This is a native swiper function data-swiper-autoplay in the swiper-slide
    //             var autoPlayValue = jQuery('.slideshow-main .swiper-slide').data("swiper-autoplay")
    //
    //             var $autoplay = autoPlayValue ? {
    //                 delay: autoPlayValue,
    //                 disableOnInteraction: false
    //             } : autoPlayValue;
    //
    //             window.slideShowMain = new Swiper(".slideshow-main", {
    //                 // lazy: false,
    //                 // lazy: {
    //                 //     // Instead of swiper lazy fullwidth function
    //                 //     loadPrevNext: true,
    //                 //     loadOnTransitionStart: true, // Start loading before pressing the next slide
    //                 //     loadPrevNextAmount: 2
    //                 // },
    //                 loop: false, // check Needs to resend the text for the animation
    //                 parallax: true,
    //                 longSwipesRatio: 0.3, // Grab to move to next/prev slide
    //                 grabCursor: true,
    //                 speed: 1000,
    //                 autoplay: $autoplay,
    //                 resistanceRatio: 0,
    //                 preventInteractionOnTransition: true, // No actions during transition
    //                 pagination: {
    //                     el: ".container-slideshow .bullets-pagination",
    //                     modifierClass: "bullets-pagination-",
    //                     dynamicBullets: false, // It will keep only few bullets visible at the same time.
    //                     dynamicMainBullets: 1, // The number of main bullets visible when dynamicBullets enabled.
    //                     clickable: true,
    //                     renderBullet: renderSliderBullets,
    //
    //                 },
    //                 navigation: {
    //                     nextEl: ".container-slideshow .swiper-button-next.swiper-next-border",
    //                     prevEl: ".container-slideshow .swiper-button-prev.swiper-prev-border",
    //                 },
    //                 // Events
    //                 on: {
    //                     slideChangeTransitionStart: function () {
    //                         if (window.playerRun != null) {
    //                             // Stop the video if is playing and use the navigation
    //                             // console.log(window.playerRun.playing)
    //                             if (window.playerRun.playing || window.playerRun.paused) {
    //                                 console.log('Stop Video')
    //                                 window.playerRun.destroy();
    //                                 hideVideo();
    //                             }
    //                         }
    //                         // if (autoplayVideo) {
    //                         //     // Autoplay on change slide
    //                         //     var actualSliderVideo = jQuery('#slideshow .swiper-slide-active .play-video');
    //                         //     tajexotica_autoplay(actualSliderVideo);
    //                         // }
    //                     },
    //
    //                     init: function (swiper) {
    //                         // If loop is enabled
    //                         // tajexotica_page_header_animation()
    //                         // swiper.update();
    //                     }
    //                 }
    //             });
    //
    //             // Autoplay on load
    //             if (autoplayVideo && !is_mobile) {
    //                 var actualSliderVideo = jQuery('#slideshow .swiper-slide-active .play-video');
    //                 tajexotica_autoplay(actualSliderVideo);
    //             }
    //
    //             function tajexotica_autoplay(slideVideo) {
    //                 if (slideVideo.length > 0) {
    //                     var platformVideo = slideVideo.data('provider');
    //                     var video_id = slideVideo.data('video-id');
    //                     setTimeout(function () {
    //                         // Added time to load plyr
    //                         tajexotica_video_play(video_id, platformVideo);
    //                     }, 0) // First 1000, First 200
    //
    //                 }
    //             }
    //
    //         }
    //     } else {
    //         console.log('Too fast.. ');
    //     }
    // }

    // Gallery, Experiences, Activities
    function tajexotica_slider_full() {
        if (typeof Swiper !== 'undefined') {
            if ($(".start-full-carousel").length) {
                $(".start-full-carousel").each(function () {

                    var $infoFullSlider = $(this);

                    // Data attributes
                    // ================
                    var $dataHaveFancybox = $infoFullSlider.data("slider-fancybox");
                    var $dataSimulateTouch = $infoFullSlider.data("simulate-touch");
                    var $dataGrabCursor = $infoFullSlider.data("grab-cursor");
                    var $dataAutoplay = $infoFullSlider.data("autoplay") ? {
                        delay: $infoFullSlider.data("autoplay"),
                        disableOnInteraction: !$dataHaveFancybox // Stop autoplay in any action
                    } : $infoFullSlider.data("autoplay");


                    if ($infoFullSlider.is("[data-slider-speed]")) {
                        var $dataSpeed = $infoFullSlider.data("slider-speed");
                    } else {
                        var $dataSpeed = 900; // by default
                    }


                    // Check if have more elements to active the loop
                    var $dataElements = $infoFullSlider.data("elements");

                    var $startSlider
                    if (!is_mobile) {
                        $startSlider = parseInt($dataElements) < $infoFullSlider.find('.swiper-slide').length; // Show if have more than dataElements
                    } else {
                        // $startSlider = $infoFullSlider.find('.swiper-slide').length > 1; // Show if have more than 1 item
                        $startSlider = parseInt($dataElements) < $infoFullSlider.find('.swiper-slide').length; // Show if have more than dataElements
                    }

                    if ($startSlider) {
                        // Init Swiper
                        // =============
                        // Delete justify-content: center if start the slider. It brake it
                        // If have one center with justify content center, if no remove the center
                        // if (is_mobile) {
                        $infoFullSlider.find(".swiper-wrapper")[0].style.justifyContent = 'flex-start'; // Default value
                        // }


                        var $startFullSwiper = new Swiper($infoFullSlider.find(".swiper-container")[0], {
                            // Parameters
                            direction: "horizontal",
                            effect: "slide",
                            speed: 600, // slider speed for smaller screens (when window width is 996px or smaller)
                            parallax: true,
                            resistanceRatio: 0,
                            longSwipesRatio: 0.02,
                            watchSlidesProgress: true, // If you use slidesPerView: 'auto' enable watchSlidesProgress
                            preventInteractionOnTransition: true, // No actions during transition
                            autoplay: $dataAutoplay,
                            simulateTouch: $dataSimulateTouch,
                            grabCursor: $dataGrabCursor,
                            // initialSlide: 0,
                            slidesPerView: 'auto',
                            centeredSlides: true,
                            loop: true,
                            loopedSlides: 3,
                            preloadImages: false, // Needed for lazy loading

                            lazy: {
                                loadPrevNext: true,
                                loadOnTransitionStart: true,
                                loadPrevNextAmount: 2, // Amount of next/prev slides to preload lazy images in.
                                // Improve loading before instead in the same moment
                            },

                            breakpoints: {
                                // when window width is 1025px or larger
                                996: {
                                    speed: $dataSpeed,
                                }
                            },

                            // Navigation arrows
                            navigation: {
                                nextEl: $(this).find(".swiper-next-border")[0],
                                prevEl: $(this).find(".swiper-prev-border")[0],
                            },

                            // Events
                            on: {
                                init: function () {
                                    var imagesSlider = Array.from($infoFullSlider.find('.lazy_img'));
                                    tajexotica_lazy_load_img(imagesSlider);
                                },
                                afterInit: function () {
                                    $infoFullSlider.find(".swiper-wrapper")[0].style.opacity = '1'; // To finish loading then load the opacity. Avoid movements
                                },
                            }
                        });

                        // When open the Fancybox stop the autoplay
                        if ($dataHaveFancybox) {
                            $infoFullSlider.find(".swiper-container .swiper-slide a").click(function () {
                                (this).closest('.swiper-container').swiper.autoplay.stop(); // Stop AutoPlay
                                // End of this function on fancybox Close afterClose
                            });
                        }
                    } else {
                        $infoFullSlider.find(".swiper-wrapper")[0].style.opacity = '1';
                    }

                });
            }
        }
    }

    // Filter Slider
    function tajexotica_slider_filter() {
        if (typeof Swiper !== 'undefined') {
            if ($(".start-filter-carousel").length) {
                $(".start-filter-carousel").each(function () {

                    var $infoFilterSlider = $(this);

                    // Data attributes
                    // ================
                    var $dataHaveFancybox = $infoFilterSlider.data("slider-fancybox");
                    var $dataSimulateTouch = $infoFilterSlider.data("simulate-touch");
                    var $dataGrabCursor = $infoFilterSlider.data("grab-cursor");
                    var $dataAutoplay = $infoFilterSlider.data("autoplay") ? {
                        delay: $infoFilterSlider.data("autoplay"),
                        disableOnInteraction: !$dataHaveFancybox // Stop autoplay in any action
                    } : $infoFilterSlider.data("autoplay");


                    if ($infoFilterSlider.is("[data-slider-speed]")) {
                        var $dataSpeed = $infoFilterSlider.data("slider-speed");
                    } else {
                        var $dataSpeed = 900; // by default
                    }

                    // Init Swiper
                    // =============
                    // Delete justify-content: center if start the slider. It brake it
                    // If have one center with justify content center, if no remove the center
                    // if (is_mobile) {
                    $infoFilterSlider.find(".swiper-wrapper")[0].style.justifyContent = 'flex-start'; // Default value
                    // }

                    // Check if have more elements to active the loop
                    var $dataElements = $infoFilterSlider.data("elements");

                    var $startSlider
                    if (!is_mobile) {
                        $startSlider = parseInt($dataElements) < $infoFilterSlider.find('.swiper-slide').length; // Show if have more than dataElements
                    } else {
                        $startSlider = $infoFilterSlider.find('.swiper-slide').length > 1; // Show if have more than 1 item
                    }

                    if ($startSlider) {
                        taj_filter_slider_run();

                        function taj_filter_slider_run() {
                            window.startFilterSwiper = new Swiper($infoFilterSlider.find(".swiper-container")[0], {
                                // Parameters
                                direction: "horizontal",
                                effect: "slide",
                                speed: 600, // slider speed for smaller screens (when window width is 996px or smaller)
                                parallax: true,
                                resistanceRatio: 0,
                                longSwipesRatio: 0.02,
                                watchSlidesProgress: true, // If you use slidesPerView: 'auto' enable watchSlidesProgress
                                preventInteractionOnTransition: true, // No actions during transition
                                autoplay: $dataAutoplay,
                                simulateTouch: $dataSimulateTouch,
                                grabCursor: $dataGrabCursor,
                                // initialSlide: 0,
                                slidesPerView: 'auto',
                                centeredSlides: true,
                                loop: false, // Avoid breaking the sliders (Filters)
                                loopedSlides: 1,
                                preloadImages: false, // Needed for lazy loading
                                observer: true,
                                runCallbacksOnInit: true,
                                // updateOnImagesReady: true, // Need preloadImages
                                // autoHeight: true,

                                lazy: {
                                    loadPrevNext: true,
                                    loadOnTransitionStart: true,
                                    loadPrevNextAmount: 2, // Amount of next/prev slides to preload lazy images in.
                                    // Improve loading before instead in the same moment
                                },

                                breakpoints: {
                                    // when window width is 1025px or larger
                                    996: {
                                        speed: $dataSpeed,
                                    }
                                },

                                // Navigation arrows
                                navigation: {
                                    nextEl: $infoFilterSlider.find(".swiper-next-border")[0],
                                    prevEl: $infoFilterSlider.find(".swiper-prev-border")[0],
                                },

                                // Events
                                on: {
                                    init: function () {
                                        var imagesSlider = Array.from($infoFilterSlider.find('.lazy_img'));
                                        tajexotica_lazy_load_img(imagesSlider);
                                    },
                                    afterInit: function () {
                                        $infoFilterSlider.find(".swiper-wrapper")[0].style.opacity = '1'; // To finish loading then load the opacity. Avoid movements
                                    },
                                }
                            });
                        }

                        // When open the Fancybox stop the autoplay
                        // if ($dataHaveFancybox) {
                        //     $infoFilterSlider.find(".swiper-container .swiper-slide a").click(function () {
                        //         (this).closest('.swiper-container').swiper.autoplay.stop(); // Stop AutoPlay
                        //         // End of this function on fancybox Close afterClose
                        //     });
                        // }


                        var sliderFilter = jQuery('#data-filter-slider .filter-options-to-click');

                        function tajexotica_slider_filter_value(valueFilterSlider) {
                            window.startFilterSwiper.destroy();

                            // Need the hidden-slider-filter to avoid showing the slider in first interaction (Not used in this case, is All)
                            // Remove swiper-slide class that don't have the filter selected and add display none

                            $infoFilterSlider.find(".slider-filter-item").not("[data-filter*='" + valueFilterSlider + "']").addClass("non-swiper-slide").removeClass("swiper-slide").hide();
                            // Remove non-swiper-slide and add the swiper-slide to the filter selected and show
                            $infoFilterSlider.find('.slider-filter-item.non-swiper-slide[data-filter*="' + valueFilterSlider + '"]').removeClass("non-swiper-slide").addClass("swiper-slide").attr("style", null).show();
                            taj_filter_slider_run();
                        }

                        if (!is_mobile) {
                            if (sliderFilter) {
                                sliderFilter.on("click", function (e) {
                                    e.preventDefault();
                                    var valueFilterSlider = $(this).data('filter');
                                    // console.log(valueFilterSlider);
                                    sliderFilter.removeClass("is-checked");
                                    $(this).addClass('is-checked');
                                    tajexotica_slider_filter_value(valueFilterSlider);
                                });
                            }
                        }


                        if (is_mobile) {
                            var sliderFilterSelect = jQuery('#select-filter-2');
                            // Bind filter on select change
                            sliderFilterSelect.on('change', function () {
                                var value = $(this).val();
                                tajexotica_slider_filter_value(value);
                            });
                        }

                    } else {
                        $infoFilterSlider.find(".swiper-wrapper")[0].style.opacity = '1';
                    }

                });
            }
        }
    }

    // Small slider for the blocks
    function tajexotica_slider_small() {
        if (typeof Swiper !== 'undefined') {
            if ($(".start-small-carousel").length) {
                $(".start-small-carousel").each(function () {

                    var $infoSmallSlider = $(this);

                    // Data attributes
                    // ================
                    var $dataSimulateTouch = $infoSmallSlider.data("simulate-touch");
                    var $dataGrabCursor = $infoSmallSlider.data("grab-cursor");
                    var $dataAutoplay = $infoSmallSlider.data("autoplay") ? {
                        delay: $infoSmallSlider.data("autoplay")
                    } : $infoSmallSlider.data("autoplay");


                    if ($infoSmallSlider.is("[data-slider-speed]")) {
                        var $dataSpeed = $infoSmallSlider.data("slider-speed");
                    } else {
                        var $dataSpeed = 900; // by default
                    }


                    var renderSliderBullets = function (index, className) {
                        return '<span class="' + className + ' swiper-pagination-bullet--svg-animation">' +
                            '<svg width="26" height="26" viewBox="0 0 28 28">' +
                            '<circle class="svg__circle" cx="14" cy="14" r="12" fill="none" stroke-width="2">' +
                            '</circle>' +
                            '<circle class="svg__circle-inner" cx="14" cy="14" r="6" stroke-width="3">' +
                            '</circle>' +
                            '</svg>' +
                            '</span>';
                    }

                    // Init Swiper
                    // =============

                    var $slidersCount = $infoSmallSlider.find('.swiper-slide')
                    var disableMovingOneSlide = $slidersCount.length > 1;

                    var $startFullSwiper = new Swiper($infoSmallSlider.find(".swiper-container")[0], {
                        // Parameters
                        direction: "horizontal",
                        effect: "slide",
                        speed: 600, // slider speed for smaller screens (when window width is 996px or smaller)
                        parallax: true,
                        resistanceRatio: 0,
                        longSwipesRatio: 0.02,
                        watchSlidesProgress: true, // If you use slidesPerView: 'auto' enable watchSlidesProgress
                        preventInteractionOnTransition: true, // No actions during transition
                        autoplay: $dataAutoplay,
                        simulateTouch: $dataSimulateTouch,
                        grabCursor: $dataGrabCursor,
                        // initialSlide: 0,
                        slidesPerView: 'auto',
                        centeredSlides: false,
                        loop: false,
                        loopedSlides: 1,
                        allowTouchMove: disableMovingOneSlide, // To avoid grabbing if is one slide
                        preloadImages: false, // Needed for lazy loading

                        lazy: {
                            loadPrevNext: true,
                            loadOnTransitionStart: true,
                            loadPrevNextAmount: 2, // Amount of next/prev slides to preload lazy images in.
                            // Improve loading before instead in the same moment
                        },

                        breakpoints: {
                            // when window width is 1025px or larger
                            996: {
                                speed: $dataSpeed,
                            }
                        },

                        // Bullets
                        pagination: {
                            el: $infoSmallSlider.find(".bullets-pagination")[0],
                            modifierClass: "bullets-pagination-",
                            dynamicBullets: false, // It will keep only few bullets visible at the same time.
                            dynamicMainBullets: 1, // The number of main bullets visible when dynamicBullets enabled.
                            clickable: true,
                            renderBullet: renderSliderBullets,
                        },

                        // Events
                        on: {
                            init: function () {
                                var imagesSlider = Array.from($infoSmallSlider.find('.lazy_img'));
                                tajexotica_lazy_load_img(imagesSlider);
                            },
                        }
                    });

                });
            }
        }
    }

    // Slider with thumbnail
    function tajexotica_slider_thumbnail() {
        if (typeof Swiper !== 'undefined') {

            // NO LOOP
            if ($(".start-thumbnail-carousel").length) {
                $(".start-thumbnail-carousel").each(function () {

                    var $infoSliderWithThumb = $(this);

                    // Data attributes
                    // ================
                    var $dataHaveFancybox = $infoSliderWithThumb.data("slider-fancybox");
                    var $dataSimulateTouch = $infoSliderWithThumb.data("simulate-touch");
                    var $dataGrabCursor = $infoSliderWithThumb.data("grab-cursor");
                    var $dataAutoplay = $infoSliderWithThumb.data("autoplay") ? {
                        delay: $infoSliderWithThumb.data("autoplay"),
                        // disableOnInteraction: !$dataHaveFancybox // Stop autoplay in any action
                        disableOnInteraction: false // Stop autoplay in any action
                    } : $infoSliderWithThumb.data("autoplay");


                    if ($infoSliderWithThumb.is("[data-slider-speed]")) {
                        var $dataSpeed = $infoSliderWithThumb.data("slider-speed");
                    } else {
                        var $dataSpeed = 900; // by default
                    }

                    // Init Swiper
                    // =============
                    // Delete justify-content: center if start the slider. It brake it
                    // If have one center with justify content center, if no remove the center
                    // if (is_mobile) {
                    // $infoSliderWithThumb.find(".swiper-wrapper")[0].style.justifyContent = 'flex-start'; // Default value
                    // }

                    var moreThanOne = false;
                    if ($infoSliderWithThumb.find(".slider-thumbnail")[0]) {
                        var sliderThumbnail = new Swiper($infoSliderWithThumb.find(".slider-thumbnail")[0], {
                            slidesPerView: 'auto', // Auto if not it show spaces
                            // freeMode: true,
                            grabCursor: true,
                            watchSlidesVisibility: true,
                            watchSlidesProgress: true,
                            watchOverflow: true, // To follow the index
                        });
                        moreThanOne = true;
                    }

                    var $startThumbSwiper = new Swiper($infoSliderWithThumb.find(".swiper-container")[0], {
                        // Parameters
                        direction: "horizontal",
                        effect: "slide",
                        speed: 600, // slider speed for smaller screens (when window width is 996px or smaller)
                        parallax: true,
                        resistanceRatio: 0,
                        longSwipesRatio: 0.02,
                        watchSlidesProgress: true, // If you use slidesPerView: 'auto' enable watchSlidesProgress
                        preventInteractionOnTransition: true, // No actions during transition
                        autoplay: $dataAutoplay,
                        simulateTouch: $dataSimulateTouch,
                        grabCursor: $dataGrabCursor,
                        // initialSlide: 0,
                        slidesPerView: 1,
                        // centeredSlides: true,
                        loop: false,
                        loopedSlides: null,
                        preloadImages: false, // Needed for lazy loading

                        lazy: {
                            loadPrevNext: true,
                            loadOnTransitionStart: true,
                            loadPrevNextAmount: 2, // Amount of next/prev slides to preload lazy images in.
                            // Improve loading before instead in the same moment
                        },

                        breakpoints: {
                            // when window width is 1025px or larger
                            996: {
                                speed: $dataSpeed,
                            }
                        },

                        // Navigation arrows
                        navigation: {
                            nextEl: $(this).find(".swiper-button-next")[0],
                            prevEl: $(this).find(".swiper-button-prev")[0],
                        },

                        // Pagination Counter
                        pagination: {
                            el: $infoSliderWithThumb.find(".counter-nav-pagination")[0],
                            type: 'fraction',
                            modifierClass: "nav-pagination-", // To avoid using the Swiper classes
                        },

                        // Thumbnail controller
                        thumbs: {
                            swiper: moreThanOne ? sliderThumbnail : null,
                        },

                        // Events
                        on: {
                            init: function () {
                                var imagesSlider = Array.from($infoSliderWithThumb.find('.lazy_img'));
                                tajexotica_lazy_load_img(imagesSlider);
                            },
                            afterInit: function () {
                                $infoSliderWithThumb.find(".swiper-wrapper")[0].style.opacity = '1'; // To finish loading then load the opacity. Avoid movements
                            },

                            // To follow the index. To force to change the Index in the Thumbs
                            slideChangeTransitionStart: function () {
                                sliderThumbnail.slideTo($startThumbSwiper.activeIndex);
                            },

                            // To follow the index
                            transitionStart: function () {
                                sliderThumbnail.slideTo($startThumbSwiper.activeIndex);
                            },
                        }
                    });

                    // When open the Fancybox stop the autoplay
                    if ($dataHaveFancybox) {
                        $infoSliderWithThumb.find(".swiper-container .swiper-slide a").click(function () {
                            (this).closest('.swiper-container').swiper.autoplay.stop(); // Stop AutoPlay
                            // End of this function on fancybox Close afterClose
                        });
                    }

                });
            }
        }
    }

    /////////////// ==== Sliders End ==== ///////////////


    /////////////// ==== FancyBox Start ==== ///////////////

    function tajexotica_fancybox_popup() {
        // Ultra speed, Fancybox popup with Cookie for 1 day
        // Fancybox loaded with ewdelayedscript
        var fancy_popup = $('#popup-box');
        if (fancy_popup.length) {
            // 2 Hours. Then use the expireCookiesHours in expires: expireCookiesHours
            // var expireCookiesHours = new Date(new Date().getTime() + 2 * 60 * 60 * 1000);
            // 15 minutes
            // var expireCookiesMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
            var active = Cookies.get('active');
            if (active === 'yes') {
                // Change to 'no' if you want to disable the Cookie and test
                return false;
            } else {
                console.log('Fancybox PopUp Readed. It will start start in: ' + delay_to_show_popup + ' second/s')
                setTimeout(function () {
                    if (typeof jQuery.fancybox != 'undefined') {
                        fancy_popup.fancybox({
                            beforeLoad: function () {
                                jQuery('#popup-box .container-popup-block').css('display', 'flex');
                                jQuery('#popup-box').css('display', 'block');
                                tajexotica_disablescrolling();

                                // Add image border Logo on lazy (is CSS after)
                                // Inline, no Link, is better
                                // Inline, no Link, is better
                                var css = '.container-popup-block:after {background: url("' + theme_url + '/img/favicon_logo_white.png");}';
                                head = document.head || document.getElementsByTagName('head')[0],
                                    style = document.createElement('style');

                                head.appendChild(style);

                                style.type = 'text/css';
                                if (style.styleSheet) {
                                    // This is required for IE8 and below.
                                    style.styleSheet.cssText = css;
                                } else {
                                    style.appendChild(document.createTextNode(css));
                                }
                            },
                            beforeClose: function (instance, current) {
                                tajexotica_enablescrolling();
                            },
                            animationEffect: "zoom-in-out",
                            touch: false,
                            scrolling: 'auto',
                        })

                        fancy_popup.trigger('click');
                        // With beforeshow didn't work
                        jQuery('.fancybox-content').css({
                            'background': 'transparent',
                            'padding': 0,
                        });
                        // Autoclose function
                        // setTimeout(function(){
                        //     $.fancybox.close();
                        // }, 5000)
                    }
                    // }, 750);
                }, delay_to_show_popup * 1000);
            }

            if (document.location.protocol === 'http:') {
                Cookies.set('active', 'yes', {
                    sameSite: 'lax', // Change to none when is HTTPS
                    secure: false, // Active when is HTTPS
                    expires: 1 // The number of days cookie will be effective
                });
            } else {
                Cookies.set('active', 'yes', {
                    sameSite: 'strict', // Change to none when is HTTPS
                    secure: true, // Active when is HTTPS
                    expires: 1 // The number of days cookie will be effective
                });
            }


        }
    }

    function tajexotica_fancybox_callback() {

        // =========== GENERAL ===========

        if (typeof $.fancybox !== 'undefined') {

            var mediaFullDesktop = window.matchMedia('(max-width: 920px)');
            $('.swiper-slide [data-group], [data-fancybox]:not([data-fancybox="gallery-photogallery"]):not([data-fancybox="new-photogallery"])').fancybox({
                animationEffect: "zoom-in-out",
                animationDuration: 350,
                transitionEffect: "fade",
                transitionDuration: 1500,
                wheel: false,
                arrows: true,
                backFocus: false, // Return the focus to the element clicked. true is not working 100%, but need to return
                // to the element. Make with afterClose
                autoFocus: false,
                infinite: false,
                trapFocus: false,
                placeFocusBack: false,
                buttons: [
                    'fullScreen',
                    'close'
                ],
                touch: false,
                loop: true, // loop: false,
                infobar: false, // Hide number for clone
                // Enable keyboard navigation
                keyboard: true,
                hash: false, // Dont add the hash # to link
                mobile: {
                    // Fix mobile on next/before pass two slides instead of one
                    preventCaptionOverlap: !1,
                    // idleTime: !1,
                    clickContent: function (t, e) {
                        return "image" === t.type && "zoom";
                    },
                    clickSlide: function (t, e) {
                        return "image" === t.type && "close";
                    },
                    touch: false,
                },
                // Disable double click, moves two images in mobile and tablet
                beforeShow: function (instance, current) {
                    tajexotica_disablescrolling();
                },

                afterShow: function (instance, current) {
                    if (mediaFullDesktop.matches) {
                        jQuery(".fancybox-navigation button").on('click', function (event) {
                            event.preventDefault();
                            jQuery(this).prop('disabled', true);
                        });
                    }
                },

                beforeClose: function (instance, current) {
                    var actualFancyGroup = current.opts.group;
                    var elementsOpenFancyBox = jQuery("[data-group='" + actualFancyGroup + "']").closest('.swiper-container');
                    if (elementsOpenFancyBox.length > 0) {
                        if (elementsOpenFancyBox[0].attributes.datafancyswiperautoplay != null) { // Check if this fancybox is a slider autoplay
                            // Play again the autoplay on Fancybox close
                            if (elementsOpenFancyBox[0].attributes.datafancyswiperautoplay.value > 0) {
                                // Use the value if is 0 will produce fast autoplay
                                // Check if have autoplay, if is bigger than 0
                                elementsOpenFancyBox[0].swiper.autoplay.start();
                                // Need the time.. So if you play and stop video the autoplay won't work after. Fix: Added swiper-slide data-swiper-autoplay
                            }
                        }
                    }

                },
                afterClose: function () {
                    tajexotica_enablescrolling();
                }
            });
        }
    }

    function tajexotica_fancybox_photogallery() {
        if (typeof $.fancybox !== 'undefined') {

            // Photogallery fancybox Callback
            var mediaFullDesktop = window.matchMedia('(max-width: 920px)');
            /* Set individual effect or options */
            var fancy_block_check = $('[data-fancybox="gallery-photogallery"], [data-fancybox="new-photogallery"]');
            if (fancy_block_check.length) {
                fancy_block_check.fancybox({
                    animationEffect: "zoom-in-out",
                    animationDuration: 350,
                    transitionEffect: "fade",
                    transitionDuration: 1500,
                    wheel: false,
                    arrows: true,
                    backFocus: false, // Return the focus to the element clicked. true is not working 100%, but need to return
                    // to the element. Make with afterClose
                    autoFocus: false,
                    infinite: false,
                    trapFocus: false,
                    placeFocusBack: false,
                    buttons: [
                        'fullScreen',
                        'close'
                    ],
                    youtube: {
                        controls: 0,
                        showinfo: 0
                    },
                    vimeo: {
                        color: 'f00'
                    },
                    touch: false,
                    loop: true, // loop: false,
                    infobar: true, // Hide number for clone
                    // Enable keyboard navigation
                    keyboard: true,
                    hash: false, // Dont add the hash # to link
                    mobile: {
                        // Fix mobile on next/before pass two slides instead of one
                        preventCaptionOverlap: !1,
                        // idleTime: !1,
                        clickContent: function (t, e) {
                            return "image" === t.type && "zoom";
                        },
                        clickSlide: function (t, e) {
                            return "image" === t.type && "close";
                        },
                        // touch: true,
                        touch: false,
                        // arrows: false,
                    },
                    beforeShow: function (instance, current) {
                        tajexotica_disablescrolling();
                    },

                    // Disable double click, moves two images in mobile and tablet
                    afterShow: function (instance, current) {
                        if (mediaFullDesktop.matches) {
                            jQuery(".fancybox-navigation button").on('click', function (event) {
                                event.preventDefault();
                                jQuery(this).prop('disabled', true);
                            });
                        }
                    },
                    afterClose: function (instance, current) {
                        tajexotica_enablescrolling();
                    }
                });
            }
        }
    }

    /////////////// ==== FancyBox End ==== ///////////////


    /////////////// ==== Filters Start ==== ///////////////

    function tajexotica_filter_line() {
        // Filter for Line
        ;(function ($) {
            var filter_block_container = $('.block-container-filter');
            if (filter_block_container.length) {

                var data_filters = $('#data-filters-blocks');

                var $grid = filter_block_container.isotope({
                    itemSelector: '.block-to-filter',
                    layoutMode: 'fitRows',
                    // transitionDuration: '0.5s',
                    transitionDuration: '0',
                    transformsEnabled: false,
                });

                var filterValueLine;

                // Let the animation finish
                $grid.on('arrangeComplete', function (event, filteredItems) {
                    // console.log('Transition running')
                    var itemDisplaying = jQuery(".block-to-filter:not([style*='display: none'])")
                    // console.log(itemDisplaying);
                    itemDisplaying.addClass('opacity-animation-photo');
                });


                data_filters.on('click', 'a', function () {
                    data_filters.find('.filter-options-to-click').removeClass('is-checked');

                    // Reset all the data-fancybox
                    var itemDisplaying = jQuery(".block-to-filter");
                    // itemDisplaying.attr('data-fancybox', 'gallery-photogallery');
                    itemDisplaying.removeClass('opacity-animation-photo');

                    $(this).addClass('is-checked');
                    filterValueLine = $(this).attr('data-filter');
                    $grid.isotope({filter: filterValueLine});

                    // Refresh ScrollTrigger
                    setTimeout(function () {
                        ScrollTrigger.refresh(true);
                    }, 500);
                })


            }
        })(jQuery);
    }

    function tajexotica_filter_select() {
        // Filter for Line
        ;(function ($) {
            var filter_block_container = $('.block-container-filter');
            if (filter_block_container.length) {

                var data_filters = $('#select-filter');

                var $grid = filter_block_container.isotope({
                    itemSelector: '.block-to-filter',
                    layoutMode: 'fitRows',
                    // transitionDuration: '0.5s',
                    transitionDuration: '0',
                    transformsEnabled: false,
                });

                // Let the animation finish
                $grid.on('arrangeComplete', function (event, filteredItems) {
                    // console.log('Transition running')
                    var itemDisplaying = jQuery(".block-to-filter:not([style*='display: none'])")
                    // console.log(itemDisplaying);
                    itemDisplaying.addClass('opacity-animation-photo');
                });

                // Bind filter on select change
                data_filters.on('change', function () {
                    var value = $(this).val();
                    // Get filter value from option value

                    $grid.isotope({filter: value});

                    // Refresh ScrollTrigger
                    setTimeout(function () {
                        ScrollTrigger.refresh(true); // safe: Boolean
                        // If true, it will wait for at least one requestAnimationFrame tick, and up to roughly
                        // 200ms before initiating the refresh.
                    }, 500);
                });


            }
        })(jQuery);
    }

    // Photogallery
    function tajexotica_filter_photogallery() {
        // Filter for Photogallery
        ;(function ($) {
            var filter_photogallery_select = $('.photogallery-block');
            if (filter_photogallery_select.length) {

                var data_filters = $('#data-filters-images');

                var $grid = filter_photogallery_select.isotope({
                    itemSelector: '.item-photogallery',
                    // layoutMode: 'fitRows',
                    // transitionDuration: '0.5s',
                    masonry: {
                        columnWidth: '.grid-sizer',
                        // gutter: '.gutter-sizer',
                        gutter: 16,
                        horizontalOrder: true
                    },
                    transitionDuration: '0',
                    transformsEnabled: false,
                });

                var filterValuePhoto;

                if (!is_mobile) {
                    // Masonry Element 5 is moving before Isotope load
                    jQuery(".img-wrap-photogallery").removeClass('transform-masonry-gallery');
                }

                // Let the animation finish
                $grid.on('arrangeComplete', function (event, filteredItems) {
                    // console.log('Transition running')
                    var itemDisplaying = jQuery(".img-wrap-photogallery:not([style*='display: none'])");
                    // console.log(itemDisplaying);

                    [...filteredItems].forEach(function (elmm, index) {
                            if (index % 2 === 0) {
                                elmm.element.classList.add('height-bigger');
                            }
                        }
                    );
                    var galleryItems = itemDisplaying.find('.photogallery-block-img-video');
                    galleryItems.attr('data-fancybox', 'new-photogallery').addClass('opacity-animation-photo');
                    $grid.isotope('layout');

                    // Refresh ScrollTrigger
                    setTimeout(function () {
                        ScrollTrigger.refresh(true);
                    }, 100);
                });


                data_filters.on('click', '.filter-options-to-click', function () {
                    data_filters.find('.filter-options-to-click').removeClass('is-checked');

                    // Reset all the data-fancybox
                    var itemDisplaying = jQuery(".img-wrap-photogallery");
                    itemDisplaying.removeClass('height-bigger');
                    var galleryItems = itemDisplaying.find('.photogallery-block-img-video');
                    galleryItems.attr('data-fancybox', 'gallery-photogallery');
                    galleryItems.removeClass('opacity-animation-photo');

                    $(this).addClass('is-checked');
                    filterValuePhoto = $(this).attr('data-filter');
                    $grid.isotope({filter: filterValuePhoto});
                })


            }
        })(jQuery);
    }

    // Photogallery
    function tajexotica_filter_by_select(grid_block, filterselect, item_block) {
        // Filter for Select
        // Also is different that the next don't have opacity anim, have the transition and is for all
        // So, added the check for item_block
        ;(function ($) {
            if (grid_block.length) {
                var $grid = grid_block.isotope({
                    itemSelector: item_block,
                    layoutMode: 'fitRows',
                    transitionDuration: '0.6s',
                    transformsEnabled: false,
                });

                // Check if is Photogallery and then put a specific data-fancybox value for the showed elements
                if (item_block === '.item-photogallery') {

                    $grid.on('arrangeComplete', function (event, filteredItems) {
                        var itemDisplaying = jQuery(".img-wrap-photogallery:not([style*='display: none']) .photogallery-block-img-video")
                        itemDisplaying.attr('data-fancybox', 'new-photogallery');
                    });
                }

                // Bind filter on select change
                filterselect.on('change', function () {
                    var value = $(this).val();
                    // Get filter value from option value

                    // Reset the value of data-fancybox if is Photogallery
                    if (item_block === '.item-photogallery') {
                        var itemDisplaying = jQuery(".img-wrap-photogallery .photogallery-block-img-video");
                        itemDisplaying.attr('data-fancybox', 'gallery-photogallery');
                    }

                    $grid.isotope({filter: value});

                    // // Refresh ScrollTrigger // Is giving error
                    // setTimeout(function () {
                    //     ScrollTrigger.refresh(true); // safe: Boolean
                    //     // If true, it will wait for at least one requestAnimationFrame tick, and up to roughly
                    //     // 200ms before initiating the refresh.
                    // }, 500);
                });
            }

        })(jQuery);
    }


    /////////////// ==== Filters End ==== ///////////////


    /////////////// ==== Animations Start ==== ///////////////

    // function tajexotica_prog_slideshow() {
    //     'use strict';
    //
    //     // Browser supported?
    //     var body = document.body;
    //     if (!body.getElementsByClassName || !body.querySelector || !body.classList || !body.getBoundingClientRect) return;
    //
    //     var
    //         classReplace = 'replace',
    //         classPreview = 'preview',
    //         classReveal = 'reveal',
    //         pItem = document.getElementsByClassName('progressive ' + classReplace),
    //         rAF = window.requestAnimationFrame || function (f) {
    //             f();
    //         },
    //         timer;
    //
    //     // bind events
    //     ['pageshow', 'scroll', 'resize'].forEach(function (h) {
    //         window.addEventListener(h, throttle, {passive: true});
    //     });
    //
    //     // DOM mutation observer
    //     if (window.MutationObserver) {
    //         var observer = new MutationObserver(throttle);
    //         observer.observe(body, {subtree: true, childList: true, attributes: true});
    //     }
    //
    //     // initial check
    //     inView();
    //
    //     // throttle events, no more than once every 300ms
    //     function throttle() {
    //
    //         timer = timer || setTimeout(function () {
    //             timer = null;
    //             inView();
    //         }, 300);
    //     }
    //
    //     // image in view?
    //     function inView() {
    //
    //         if (pItem.length) rAF(function () {
    //
    //             var wH = window.innerHeight, cRect, cT, cH, p = 0;
    //             while (p < pItem.length) {
    //                 cRect = pItem[p].getBoundingClientRect();
    //                 cT = cRect.top;
    //                 cH = cRect.height;
    //                 if (0 < cT + cH && wH > cT) {
    //                     loadFullImage(pItem[p]);
    //                 } else p++;
    //             }
    //         });
    //     }
    //
    //     // replace with full image
    //     function loadFullImage(item, retry) {
    //
    //         // cancel monitoring
    //         item.classList.remove(classReplace);
    //
    //         // fetch href and preview image
    //         var
    //             href = item.getAttribute('data-href') || item.href,
    //             pImg = item.querySelector('img.' + classPreview);
    //
    //         if (!href || !pImg) return;
    //
    //         // load main image
    //         var img = new Image(), ds = item.dataset;
    //
    //         if (ds) {
    //             if (ds.srcset) img.srcset = ds.srcset;
    //             if (ds.sizes) img.sizes = ds.sizes;
    //         }
    //
    //         img.onload = addImg;
    //
    //         // load failure retry
    //         retry = 1 + (retry || 0);
    //         if (retry < 3) img.onerror = function () {
    //             setTimeout(function () {
    //                 loadFullImage(item, retry);
    //             }, retry * 3000);
    //         };
    //
    //         img.src = href;
    //
    //         // replace image
    //         function addImg() {
    //
    //             // disable link
    //             if (href === item.href) {
    //                 item.style.cursor = 'default';
    //                 item.addEventListener('click', function (e) {
    //                     e.preventDefault();
    //                 });
    //             }
    //
    //             // apply image attributes
    //             var imgClass = img.classList;
    //             img.className = pImg.className;
    //             imgClass.remove(classPreview);
    //             imgClass.add(classReveal);
    //             img.alt = pImg.alt || '';
    //             img.width = pImg.width || '';
    //             img.height = pImg.height || '';
    //             img.onload = 0;
    //             img.onerror = 0;
    //
    //             rAF(function () {
    //                 // add full image
    //                 item.insertBefore(img, pImg.nextSibling).addEventListener('animationend', function () {
    //                     // remove preview image
    //                     item.removeChild(pImg);
    //                     imgClass.remove(classReveal);
    //                 });
    //             });
    //
    //         }
    //
    //     }
    //
    //
    // }

    function tajexotica_call_once(fn) {
        var called = false;
        return function () {
            if (!called) {
                called = true;
                return fn();
            }
            return;
        }
    }

    function tajexotica_appear_onscroll() {
        // Zoom in for Images
        $(".effect-anim-zoomin").each(function () {
            var $this = $(this);
            var $asiWrap = $this.parents(".anim-zoomin-wrap");

            let tl_ZoomIn = gsap.timeline({
                scrollTrigger: {
                    trigger: $asiWrap,
                    start: "top 90%",
                    markers: false,
                }
            });

            tl_ZoomIn.from($this, {duration: 1.8, autoAlpha: 0, scale: 1.2, ease: Power2.easeOut, clearProps: "all"});
        });


        // Fade in-up Img/Text
        $(".effect-anim-fadeinup").each(function () {
            let tl_FadeInUp = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: "top bottom",
                    markers: false
                }
            });

            // To maintain the opacity 1 at the end.
            tl_FadeInUp.fromTo(this, {autoAlpha: 0, y: 100}, {
                autoAlpha: 1,
                duration: 2.5,
                y: 0,
                ease: Expo.easeOut,
                delay: 0.3
            });
        });


        // Fade in-up Img/Text Small (Buttons)
        $(".effect-anim-fadeinup-small").each(function () {
            let tl_FadeInUpSmall = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: "top bottom",
                    markers: false
                }
            });


            // To maintain the opacity 1 at the end.
            tl_FadeInUpSmall.fromTo(this, {autoAlpha: 0, y: 40}, {
                autoAlpha: 1,
                duration: 2.5,
                y: 0,
                ease: Expo.easeOut,
                delay: 0.3
            });
        });


        // Skew in-up Img/Text
        $(".effect-anim-skewinup").each(function () {
            let tl_SkewInUp = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: "top bottom",
                    markers: false
                }
            });

            // To maintain the opacity 1 at the end. Starting with block opacity 0
            tl_SkewInUp.fromTo(this, {autoAlpha: 0, y: 100, skewY: 5, transformOrigin: "left top"}, {
                autoAlpha: 1,
                duration: 2,
                y: 0,
                skewY: 0,
                ease: Expo.easeOut,
                delay: 0.5
            });
        });


        // Stretch in-up Img/Text
        $(".effect-anim-stretchinup").each(function () {
            let tl_StretchInUp = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: "top bottom",
                    markers: false
                }
            });

            tl_StretchInUp.fromTo(this, {autoAlpha: 0, y: 100, scaleY: 1.4, transformOrigin: "top"}, {
                autoAlpha: 1,
                duration: 2,
                y: 0,
                scaleY: 1,
                ease: Expo.easeOut,
                delay: 0.2
            });
        });


        // Zoom In Image Effect on Hover
        document.querySelectorAll(".effect-zoom-img").forEach(function (element) {
            var animationZoomIn = gsap.timeline({paused: true});
            animationZoomIn.to(element, {scale: 1.1, duration: 1, ease: "power1.inOut"});
            element.addEventListener("mouseenter", function () {
                animationZoomIn.play();
            });
            element.addEventListener("mouseleave", function () {
                animationZoomIn.reverse();
            });
        });

        // // Zoom In Image Effect on Hover
        // document.querySelectorAll(".hub-block-one-item").forEach(function (element) {
        //     var animationZoomIn = gsap.timeline({paused: true});
        //     // console.log($(element).querySelector('.hub-one-img .swiper-wrapper'))
        //     animationZoomIn.to(element.querySelector('.hub-one-img .swiper-wrapper .swiper-slide'), {scale: 1.1, duration: 1, ease: "power1.inOut"});
        //     element.addEventListener("mouseenter", function () {
        //         animationZoomIn.play();
        //     });
        //     element.addEventListener("mouseleave", function () {
        //         animationZoomIn.reverse();
        //     });
        // });

        // Fade in-up Img/Text, but waiting the last one.
        var elsFadeBlocks = jQuery('.fade-in-up-block')
        if (elsFadeBlocks.length) {
            gsap.set(".fade-in-up-block", {opacity: 0, y: 100});
            var tlBlock;

            // Make a animation with delay (stagger 0.3), can't with a variable data-delay. Need to use batch
            // Careful using slider, because will wait some time..
            var tlFadeInUp = ScrollTrigger.batch(".fade-in-up-block", {
                // once: true,
                // id: "fadeInUpTrigger",
                // overwrite: true,
                start: "top bottom-=100px",
                interval: 0.1,
                stagger: 3,
                // ease: Circ.easeOut,
                ease: Expo.easeOut,
                onEnter: batch => {
                    // It start after the last one finish, without starting in the second line
                    if (tlBlock && tlBlock.isActive()) {
                        tlBlock.to(batch, {opacity: 1, y: 0, stagger: 0.3})
                    } else {
                        tlBlock = gsap.timeline().to(batch, {opacity: 1, y: 0, stagger: 0.3})
                    }
                },
            });

            // Kill the animation if needed.. for example filter isotope
            // tlFadeInUp.pause(0).kill(true);
            // ScrollTrigger.getAll('fadeInUpTrigger').forEach(st => st.kill(true));

            // when ScrollTrigger does a refresh(), it maps all the positioning data which
            // factors in transforms, setting all the ".fade-in-up-block"
            // elements to a "y" of 100 solely for the animation in which would throw off the normal
            // positioning, so use a "refreshInit" listener to reset the y temporarily. When
            // return a gsap.set() in the listener, it'll automatically revert it after the refresh()!
            ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".fade-in-up-block", {y: 0}));
        }


        // Batch with multiple animation inside
        if (jQuery('.effect-batch-container').length) {
            if (jQuery('.effect-batch-image').length) {
                gsap.set('.effect-batch-image', {
                    opacity: 0,
                    y: 75,
                    scale: 0.9,
                });
            }
            if (jQuery('.effect-batch-title').length) {
                gsap.set('.effect-batch-title', {
                    opacity: 0,
                    y: 50,
                });
            }
            if (jQuery('.effect-batch-text').length) {
                gsap.set('.effect-batch-text', {
                    opacity: 0,
                    y: 40,
                });
            }

            ScrollTrigger.batch('.effect-batch-container', {
                onEnter: batch => {
                    batch.forEach((card, index) => gsap.to(card.children, {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        stagger: 0.3,
                        delay: index * 0.5
                    }))
                },
                once: true
            });
        }


        // Text Movement
        $(".effect-text-anim").each(function () {
            var $effectFirstText = $(this).find(".effect-text-anim-first");
            var $effectSecondText = $(this).find(".effect-text-anim-second");
            var $effectThirdText = $(this).find(".effect-text-anim-third");

            let tl_plIInfo = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: "top bottom",
                    markers: false
                }
            });

            if ($($effectFirstText).length) {
                tl_plIInfo.fromTo($effectFirstText, {autoAlpha: 0, y: 80}, {
                    duration: 2.5,
                    autoAlpha: 1,
                    y: 0,
                    ease: Expo.easeOut,
                    // clearProps: "all"
                }, "+=0.5");
            }

            if ($($effectSecondText).length) {
                tl_plIInfo.fromTo($effectSecondText, {autoAlpha: 0, y: 60}, {
                    duration: 2.5,
                    autoAlpha: 1,
                    y: 0,
                    ease: Expo.easeOut,
                    // clearProps: "all"
                }, "-=2.2");
            }

            if ($($effectThirdText).length) {
                tl_plIInfo.fromTo($effectThirdText, {autoAlpha: 0, y: 40}, {
                    duration: 2.5,
                    autoAlpha: 1,
                    y: 0,
                    ease: Expo.easeOut,
                    // clearProps: "all"
                }, "-=2.2");
            }


        });


        // Image Gsap
        let masks = document.querySelectorAll('.effect-img-mask');

        masks.forEach(mask => {
            let image = mask.querySelector('img');

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: mask,
                    toggleActions: "play none none none" // Run Once
                }
            });

            tl.set(mask, {autoAlpha: 1});

            tl.from(mask, 1.5, {
                xPercent: -100,
                ease: Power2.out
            });

            tl.from(image, 1.5, {
                xPercent: 100,
                scale: 1.3,
                delay: -1.5,
                ease: Power2.out
            });
        })


        // Need SplitText Plugin
        var effectTexts = document.querySelectorAll(".effect-text");

        if (effectTexts !== null) {
            effectTexts.forEach(blockText => {

                let tl_splitEffect = gsap.timeline({
                    scrollTrigger: {
                        trigger: blockText,
                        start: "bottom bottom", // Start when reach the bottom
                        toggleActions: "play none none none", // Run Once
                        // The opacity is for the parent block cuz the autoAlpha is not working, (it disappears)
                        onEnter: () => disableOpacityBeforeStart(),
                    }
                });

                function disableOpacityBeforeStart() {
                    blockText.style.opacity = "1";
                }


                if (isRtlCheck) {
                    // AR is getting wrong each letter
                    blockText.split = new SplitText(blockText, {
                        type: "lines,words",
                        wordsClass: "word++",
                        linesClass: "split-line"
                    });

                    tl_splitEffect.fromTo(blockText.split.words, {autoAlpha: 0, y: 80}, {
                        duration: 0.6,
                        autoAlpha: 1,
                        y: 0,
                        ease: "circ.out",
                        stagger: 0.02,
                        // clearProps: "all"
                    });
                } else {
                    blockText.split = new SplitText(blockText, {
                        type: "lines,words,chars",
                        linesClass: "split-line"
                    });

                    tl_splitEffect.fromTo(blockText.split.chars, {autoAlpha: 0, y: 80}, {
                        duration: 0.6,
                        autoAlpha: 1,
                        y: 0,
                        ease: "circ.out",
                        stagger: 0.02,
                        // clearProps: "all"
                    });
                }
            });

        }
    }

    function tajexotica_page_header_animation() {

        if (jQuery('#slideshow').length > 0) {
            window.effectSliderParallax = gsap.timeline({
                scrollTrigger: {
                    trigger: "#slideshow",
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                    markers: false
                }
            });
        }

        var imgSliderAnim = $("#slideshow .slideshow-img-parallax")
        if (imgSliderAnim.length) {
            // imgSliderAnim.wrapInner('<div class="effect-img-parallax"></div>'); // Already on the block, to avoid blinking progress Image Animation
            // Parallax image in Mobile is not smooth for scale
            if (!is_mobile) {
                window.effectSliderParallax.to(".effect-img-parallax", {yPercent: 40}, 0);
                // window.effectSliderParallax.to(".effect-img-parallax", {yPercent: 60}, 0);
            }
            // else {
            //     window.effectSliderParallax.to(".effect-img-parallax", {yPercent: 30}, 0);
            // }

        }

        // Page header caption elements scrolling effect
        // Should use different div structure.. is inside the p. Fixed with wrap instead of wrapInner
        var firstTextSlider = $("#slideshow .text-main-slideshow .text-slider-animation");
        if (firstTextSlider.length) {
            firstTextSlider.wrap('<div class="corv-title-parallax"></div>');
            if (!is_mobile) {
                window.effectSliderParallax.to(".corv-title-parallax", {y: -60}, 0);
            } else {
                window.effectSliderParallax.to(".corv-title-parallax", {y: -80}, 0);
            }
        }

        var scrollTriggerAnim = {
            trigger: "#slideshow",
            start: "top top",
            end: "30% top",
            scrub: true,
            markers: false
        };

        // if ($("#slideshow .play-video-button").length) {
        //     gsap.to("#slideshow .play-video-button", {
        //             x: -100,
        //             // autoAlpha: 0, // Avoid Play flash if is on the first slider
        //             ease: "none",
        //             scrollTrigger: scrollTriggerAnim
        //         }
        //     );
        // }

        // Moved to the left
        // var playVideoSlider = $("#slideshow .play-video")
        // if (playVideoSlider.length) {
        //     playVideoSlider.wrapInner('<div class="effect-play-parallax"></div>');
        //     window.effectSliderParallax.to(".effect-play-parallax", {y: -100}, 0);
        // }


        if ($("#slideshow .bullets-pagination.bullets-center").length && !is_mobile) {
            gsap.to("#slideshow .bullets-pagination.bullets-center", {
                    y: -40,
                    autoAlpha: 0,
                    ease: "none",
                    scrollTrigger: scrollTriggerAnim
                }
            );
        }

        if (!isRtlCheck) {
            // RTL Check, is going to the other way
            // Navigation animation
            if ($("#slideshow .swiper-button-next.swiper-next-border").length) {
                gsap.to("#slideshow .swiper-button-next.swiper-next-border", {
                    x: +30,
                    autoAlpha: 0, // Is getting the opacity from the disabled arrow. Already tryed with clearProps: "all"
                    ease: "none",
                    scrollTrigger: scrollTriggerAnim
                });
            }

            if ($("#slideshow .swiper-button-prev.swiper-prev-border").length) {
                gsap.to("#slideshow .swiper-button-prev.swiper-prev-border", {
                    x: -30,
                    autoAlpha: 0,  // Is getting the opacity from the disabled arrow. Already tryed with clearProps: "all"
                    ease: "none",
                    scrollTrigger: scrollTriggerAnim
                });
            }


            // if ($(".circle-rotation-link").length) {
            //     gsap.to(".circle-rotation-link", {
            //         // x: -100,
            //         scale: 0.5,
            //         autoAlpha: 0,
            //         ease: "none",
            //         scrollTrigger: scrollTriggerAnim
            //     });
            // }
        }
    }

    function tajexotica_background_main_animation() {
        if (!is_mobile) {

            if (jQuery('#background-main').length > 0) {
                var timelineMainBackground = gsap.timeline({
                    scrollTrigger: {
                        // id: "ZOOM", // Custom label to the marker
                        trigger: "#background-main", // What element triggers the scroll
                        scrub: true, // Add a small delay of scrolling and animation. `true` is direct
                        // start: "top top+=100", // Start at top of Trigger and at the top of the viewport.
                        // pin: true, // Pin the element true, to maintain the element when is scrolling
                        // 100px is the header container
                        end: "+=100% 0px", // Reduce the 100% to don't scroll too much
                        start: "top top+=300", // Start at top of Trigger and at the top of the viewport.
                        pin: false, // Pin the element true, to maintain the element when is scrolling
                        toggleActions: "restart pause resume restart", // Scoll effect Forward, Leave, Back, Back Leave
                        // markers: true, // Remove markers for production.
                    }
                });


                if (jQuery('.effect-revealbackground').length > 0) {
                    timelineMainBackground.to(".effect-revealbackground", {
                            // scale: 3.8
                            scale: 1.8
                        },
                        "sameTime").to(".effect-revealitemone", {
                            x: isRtlCheck ? 500 : -500,
                            scale: 2
                        },
                        "sameTime").to(".effect-revealitemtwo", {
                            // x: 600,
                            x: isRtlCheck ? -1000 : 1000,
                            scale: 2.5
                        },
                        "sameTime");
                }
            }

        }
    }

    function tajexotica_openMenu() {
        var btn = $('#menu_btn');

        if (btn.length) {
            var sidebar = $('#menu_sidebar_wrap');
            var close = sidebar.find('.close');

            btn.on('click', function () {
                sidebar.fadeIn(function () {
                    sidebar.addClass('visible');
                });
                tajexotica_disablescrolling();
                jQuery(document).on('click', startReadingClick);
            });

            function closeMenu() {
                sidebar.removeClass('visible');
                sidebar.fadeOut();
                tajexotica_enablescrolling();
                jQuery(document).off('click', startReadingClick);
            }

            close.click(function () {
                closeMenu();
            });

            // Close clicking outside
            function startReadingClick(event) {
                var closeme = true;
                // console.log($(event.target))

                if ($(event.target).closest(btn).length > 0) {
                    closeme = false;
                }
                if ($(event.target).closest(sidebar.find('.menu_sidebar')).length > 0) {
                    closeme = false;
                }
                if (closeme) {
                    if (sidebar.hasClass('visible')) {
                        closeMenu();
                    }
                }
            }
        }


    }

    function tajexotica_scrollingblocks() {
        if (window.matchMedia('(min-width:1300px)').matches) {
            // Need 3 blocks
            var effectScrollBlocks = document.querySelectorAll(".effect-scrolling-block");

            // Remove opacity from add-opacity-anim
            if (effectScrollBlocks !== null) {
                effectScrollBlocks.forEach(blockScroll => {
                    blockScroll.style.opacity = 1;
                })
            }


            window.smoother.effects(".effect-scrolling-block", {
                speed: (i) => {
                    // Desktop three columns layout
                    // No movements in mobile
                    // if (window.matchMedia('(min-width:730px)').matches) {
                    // Center column is faster
                    return i % 3 === 1 ? 1.1 : 1;
                    // }
                }
            });
        }
    }

    function tajexotica_intersectionRefresh() {
        // Reload ScrollTo. It don't get the final size
        ;(function ($) {
            var intersectionsReload = Array.from(document.querySelectorAll('.intersection-reload-scrollto'))

            if (intersectionsReload != null) {
                if (iObserver) {
                    setupIntersectionObserver(intersectionsReload);
                } else {
                    loadIntersectionWithDelay();
                }
            }

            function setupIntersectionObserver(intersectionsReload) {
                var options = {
                    root: rootIO,
                    rootMargin: '50px 50px 50px 50px',
                    threshold: 0
                };

                var observer = new IntersectionObserver(onIntersection, options);
                intersectionsReload.forEach(intersectionPoint => observer.observe(intersectionPoint));
            }

            function onIntersection(entries, observer) {
                entries.forEach((entry) => {
                    if (entry.isIntersecting || entry.intersectionRatio > 0) {
                        observer.unobserve(entry.target);
                        console.log('Reload ScrollTo called from:');
                        console.log(entry.target);
                        // For each entry delete the observer and reload scrollTrigger refresh
                        setTimeout(function () {
                            ScrollTrigger.refresh(true);
                        }, 500);
                    }
                });
            }


            function loadIntersectionWithDelay() {
                setTimeout(function () {
                    ScrollTrigger.refresh(true);
                }, 1000);
            }


        })(jQuery);

    }

    /////////////// ==== Animations End ==== ///////////////


    /////////////// ==== Others Start ==== ///////////////

    // Is disabled by default
    function tajexotica_read_more() {
        let parentEle = document.querySelector(".read-more-text");
        const readMoreBtn = document.querySelector("#read-more-btn");
        const readMoreContainer = document.querySelector(".read-more-content");

        // Movements
        var effectRevealBg = document.querySelector(".effect-revealbackground.item-reveal img");
        var effectRevealItemOne = document.querySelector(".effect-revealitemone");
        var effectRevealItemTwo = document.querySelector(".effect-revealitemtwo");

        if (parentEle != null && readMoreContainer != null) {
            let heightNoOpen = parseInt(window.getComputedStyle(parentEle).maxHeight, 10);
            let heightTotal = 0;

            // var actualHeight = parentEle.style.height;

            setTimeout(function () {
                Array.from(parentEle.children).forEach((item) => {
                    // heightTotal = heightTotal + item.clientHeight
                    let style = window.getComputedStyle(item);
                    let height = ['height', 'margin-top', 'margin-bottom']
                        .map((key) => parseInt(style.getPropertyValue(key), 10))
                        .reduce((prev, cur) => prev + cur);
                    heightTotal = heightTotal + height;
                });
                // console.log(heightTotal)
                // console.log(heightNoOpen)

                // Show Read More if have more than X lines
                if (heightTotal > heightNoOpen) {
                    parentEle.style.height = heightNoOpen + 'px';
                    parentEle.style.maxHeight = 'none';
                    readMoreContainer.style.opacity = '1';
                    readMoreContainer.style.visibility = 'visible';
                } else { // Disable read more if is not needed
                    // readMoreContainer.style.display = 'none';
                    readMoreContainer.style.opacity = '0';
                }
            }, 100) // Wait to finish loading the font, different spaces. Also if is in the top wait to finish the animation

            var timeSetReveal = effectRevealBg != null ? 500 : 0;

            readMoreBtn.addEventListener("click", (e) => {
                if (!readMoreBtn.classList.contains('read-more-open')) {
                    // Movements
                    if (effectRevealBg != null) {
                        effectRevealItemOne.classList.toggle('movements-disappear-animation')
                        effectRevealItemTwo.classList.toggle('movements-disappear-animation')
                        effectRevealBg.style.paddingTop = heightTotal - heightNoOpen - 100 + 'px';
                    }
                    setTimeout(function () {
                        parentEle.style.height = heightTotal + 'px';
                        readMoreBtn.innerText = readLess;
                    }, timeSetReveal)
                } else {

                    // Movements
                    if (effectRevealBg != null) {
                        effectRevealItemOne.classList.toggle('movements-disappear-animation')
                        effectRevealItemTwo.classList.toggle('movements-disappear-animation')
                        effectRevealBg.style.paddingTop = '0px'
                    }
                    setTimeout(function () {
                        parentEle.style.height = heightNoOpen + 'px';
                        readMoreBtn.innerText = readMore;
                    }, 0)
                }
                readMoreBtn.classList.toggle('read-more-open')
                setTimeout(function () {
                    ScrollTrigger.refresh(true); // Refresh, is changing the size
                }, 700)
            });
        }
    }

    function tajexotica_calendar_click() {
        var btns = jQuery('.dyna-calendar');
        if (btns.length) {
            var calendar_wrapper = jQuery('#calendar_container');
            var calendarBlock = jQuery('#calendar_block');
            btns.each(function () {
                $(this).on('click', function () {
                    if (!calendar_wrapper.hasClass('visible')) {
                        calendarBlock.css('display', 'block');
                        calendar_wrapper.addClass('visible');
                        // if (!is_mobile) {
                        tajexotica_disablescrolling();
                        // }
                    }
                })
            });

            jQuery('.close_calendar').click(function () {
                if (calendar_wrapper.hasClass('visible')) {
                    calendar_wrapper.removeClass('visible');

                    // if (!is_mobile) {
                    tajexotica_enablescrolling();
                    // }
                }
            });
        }
    }

    function tajexotica_booking() {
        loadjs([website_url + '/wp-includes/js/jquery/ui/core.min.js',
                website_url + '/wp-includes/js/jquery/ui/datepicker.min.js',
                theme_url + '/js/i18n/datepicker-' + language + '.js',
            ],
            'dependencyBooking', {
                async: false,
            });

        loadjs.ready('dependencyBooking', {
            success: function () {
                // Don't change the order. ui-datepicker-trigger needs to be in the DOM
                loadjs([
                    theme_url + '/js/booking-noprices-all.min.js'
                ])
                console.log('Booking form assets Loaded');
                loadjs.done();
            }
        });
    }

    function tajexotica_menumodolazy() {
        // No need IObserver is already loaded in the js with on load
        var menuModoData = jQuery('#menumodo_data');
        if (menuModoData.length > 0) {
            menuModoData.each(function () {
                var menuData = $(this).data('block-container');
                // console.log(menuData)
                jQuery('.' + menuData).append(JSON.parse($(this).text()));
                setTimeout(function () {
                    ScrollTrigger.refresh(true); // Refresh with time to load the menumodo, is adding space
                }, 1500)
            })
        }
    }

    // Changed to global function to use in concat-integration
    window.tajexotica_disablescrolling = function () {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () {
            window.scrollTo(x, y);
        };
        tajexotica_colorScrollbar()
    }

    window.tajexotica_enablescrolling = function () {
        window.onscroll = null;
        tajexotica_colorScrollbar()
    }

    function tajexotica_colorScrollbar() {
        jQuery('body').toggleClass('hide-native-scrollbar');
        var rootFirefox = document.querySelector(':root');
        rootFirefox.classList.toggle('opened');
    }

    function tajexotica_scrollbar() {
        if (!is_mobile) {
            // Init Smooth Scrollbar
            // ======================
            gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


            // Create the divs and add to the html some code to be faster and don't wait the Js
            window.smoother = ScrollSmoother.create({
                wrapper: '#scroll-wrapper',
                content: '#scroll-container',
                smooth: 2,   // seconds it takes to "catch up" to native scroll position
                effects: true, // look for data-speed and data-lag attributes on elements and animate accordingly

                // normalizeScroll: true, // prevents address bar from showing/hiding on most devices, solves various other browser inconsistencies
                ignoreMobileResize: true, // skips ScrollTrigger.refresh() on mobile resizes from address bar showing/hiding
                preventDefault: true
            });

            // smoother.effects("img", { speed: "auto" }); // Affecting all the images
        }
    }

    // For the Contact Form Open/Close
    function tajexotica_open_block() {
        let globalBlockClose = document.querySelector(".global-block-to-close");
        const openBlockBtn = document.querySelector("#open-block-btn");
        const changeBlockTxt = document.querySelector(".open-block-btn-txt");
        const blockToOpen = document.querySelector(".block-to-open");

        if (globalBlockClose != null && blockToOpen != null) {
            let heightOpened;
            let heightClosed;

            heightOpened = globalBlockClose.offsetHeight;
            heightClosed = blockToOpen.offsetHeight;

            var heightReduced = heightOpened - heightClosed;
            globalBlockClose.style.maxHeight = heightReduced + 'px';

            openBlockBtn.addEventListener("click", (e) => {
                if (!openBlockBtn.classList.contains('block-opened')) {
                    globalBlockClose.style.maxHeight = heightOpened + 'px';
                    changeBlockTxt.innerText = closeBlockBtnTxt;
                } else {
                    globalBlockClose.style.maxHeight = heightReduced + 'px';
                    changeBlockTxt.innerText = openBlockBtnTxt;
                }
                blockToOpen.classList.toggle('hide-show-contact');
                openBlockBtn.classList.toggle('block-opened')
                setTimeout(function () {
                    ScrollTrigger.refresh(true); // Refresh, is changing the size
                }, 450) // Dont put less, need to finish the height animation 300ms
            });
        }
    }

    // Submit and Datepicker Location
    function tajexotica_submit_scrolltrigger() {
        var btns = jQuery('.wrapper-form .gform_button:submit');
        if (btns.length) {
            $(document).on('click', '.wrapper-form .gform_button:submit', function (e) {
                setTimeout(function () {
                    ScrollTrigger.refresh(true);
                    tajexotica_move_datepicker(); // When click submit the datepicker goes outside
                }, 3000); // Wait the ajax to finish sending the email. 3000 to be sure
            })
        }

        tajexotica_move_datepicker();

        // It gives an inline error when open the Datepicker, works anyway
        function tajexotica_move_datepicker() {
            // Move elements outside the scroll-content inside it.. if is fixed (Scrollbar Bug).
            if ($("body").hasClass("enable-smooth-scroll")) {
                var datepickerOut = jQuery('#ui-datepicker-div');
                var containerDate = jQuery('.ginput_container_date');
                if (datepickerOut.length > 0 && containerDate.length > 0) {
                    datepickerOut.appendTo(containerDate); // To get the correct position
                }
            }
        }
    }

    // Enable/Disable Submit Terms Confirmation + Submit click GET
    function tajexotica_form_terms() {
        // Check enable/disable Submit
        var termsConfirm = document.querySelector('#terms-confirm');
        if (termsConfirm != null) {
            termsConfirm.addEventListener('change', (event) => {
                var submitForm = document.querySelector('.container-newsletter-box #submit');
                submitForm.classList.toggle("submit-style-disabled")
            });
        }

        let regexEmail = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");

        // Get email from the mini Newsletter and send to the complete form
        function ValidateEmailAddress(emailString) {
            // check for @ sign
            // var atSymbol = emailString.indexOf("@");
            // if (atSymbol < 1) return false;
            //
            // var dot = emailString.indexOf(".");
            // if (dot <= atSymbol + 2) return false;
            //
            // // check that the dot is not at the end
            // if (dot === emailString.length - 1) return false;
            // return true;

            return regexEmail.test(emailString)
        }

        // Works only if the page Newsletter Form Template was created
        var submitGet = jQuery('.submit-mini-newsletter');
        if (submitGet.length && newsletterFormLink != null) {
            $(document).on('click', '.submit-mini-newsletter:submit', function (e) {
                // e.preventDefault(); // Is not validiting the email
                var emailValue = jQuery('.newsletterField .email-field').val();

                if (ValidateEmailAddress(emailValue)) {
                    // window.location.href = newsletterFormLink + '?email=' + emailValue; // Is showing Block PopUp
                    window.open(newsletterFormLink + '?email=' + emailValue, "_self");
                }
            })
        }
    }

    // Fix keyboard in gf
    function tajexotica_fix_keyboard_gf() {
        ;(function ($) {
            var formCheck = jQuery('.tajexotica-gf-form_wrapper');
            var datePickerCheck = jQuery('.datepicker, .hasDatepicker');
            if (formCheck.length && datePickerCheck.length) {
                datePickerCheck.attr('inputmode', 'none').attr('readonly', 'readonly');

                // Safari
                datePickerCheck.on('focus', function () {
                    jQuery(this).trigger('blur');
                });
            }
        })(jQuery);
    }

    function tajexotica_more_link_menu(menuSelector) {
        var menu = $(menuSelector);
        if (menu.length) {
            var parent = menu.find('.menu-item-has-children'),
                submenu = menu.find('.sub-menu');

            // Footer menu (Navigation, Mobile app, etc)
            menu.find('.more_li').on('click', function () {
                if (!$(this).closest(parent).hasClass('open')) {
                    parent.removeClass('open');
                    parent.find(submenu).stop().slideUp();
                    parent.find('.more_li').attr('aria-expanded', false);
                    $(this).closest(parent).find(submenu).stop().slideDown(400,
                        function () {
                            $(this).closest(parent).addClass('open');
                            $(this).closest(parent).find('.more_li').attr('aria-expanded', true);
                        }
                    );
                } else {
                    $(this).closest(parent).find(submenu).stop().slideUp(400,
                        function () {
                            $(this).closest(parent).removeClass('open');
                            $(this).closest(parent).find('.more_li').attr('aria-expanded', false);
                        }
                    );
                }
            });
        }
    }

    /////////////// ==== Others End ==== ///////////////

    //TRACKING STUFF
    //custom tracking submission forms
    function tajexotica_form_sumbission_tack() {
        jQuery(document).on("gform_confirmation_loaded", function (e, form_id) {
            console.log('confirm');
            dataLayer.push({
                event: 'Action trackings',
                'fb-ga4-dedge-id': 'G-ZNHFG337WE',
                action: 'form_submission',
                category: location.pathname.replace(/\//g, '-'),
                label: $('html').attr('lang').substr(0, 2)
            })
        });
    }


})(jQuery);
